/**
 *  Module containing functions that are used globally
 * 
 * 
 */


export function styleForm() {
    this.init = function() {
        $("li.labeled").each(function() {
            var _THIS = $(this)
            try {
                if (_THIS.find("input,textarea,select").val().length > 0) {

                    _THIS.addClass("focused");
                }

            } catch (err) {
                /*console.log(err)
                console.log(_THIS.html())
                console.log(_THIS.find("input,textarea"))*/
            }

        });

        $("li.labeled").click(function() {

            if ($(this).find("input,textarea,select").val().length == 0) {
                $(this).addClass("focused");
                $(this).find("input,textarea").focus();
            }

        });
        $("li.labeled input, li.labeled textarea").focus(function() {

            $(this).parent().addClass("focused");

        });
        $("li.labeled input, li.labeled textarea").blur(function() {

            if ($(this).val().length == 0) {
                if (!$(this).parent().hasClass("only")) {
                    $(this).parent().removeClass("focused");
                    $(this).parent().parent().removeClass("focused");
                }
            }

        });
    }
}




/** activate recently viewed on Search Container */
export function detectSearchActivation(timeout) {
    var detectTime = setTimeout(function() {
        if ($("body").hasClass("search-active")) {
            if ($("#search-recently-viewed .carousel").hasClass("hide")) {
                var instRecently = new recentlyViewed();
                instRecently.init("#search-recently-viewed");

                var insSiteSearch = new siteSearch();
                insSiteSearch.init("#search-wrapper input[type=search]");
                $("#search-wrapper input[type=search]").focus();

            }

        } else {
            $("#search-dropdown").removeClass("search-performed")
            $("#search-results").html("")
            $("#search-results").parent().find(".more-results").remove();
            $("#search-wrapper input[name=q]").val("")
            //console.log("search  not active")
        }
        clearTimeout(detectTime);

    }, timeout)
}

export function contactForm() {
    var _THIS = this;
    this.emailhasValidated = false;
    //this.phonehasValidated = false;
    this.formString = "#ContactForm";
    this.form = $(_THIS.formString)

    this.init = function() {
        //console.log("initialising My Account Register")
        registerEvents();

        (async () => {
            const {
                styleForm
            } = await import(theme.components.commonURL);
            var instStyleForm = new styleForm();
            instStyleForm.init();
        })();

    }

    var registerEvents = function() {

        //initialise the email and phone validation

        var instEmailValidate = new emailValidate();
        instEmailValidate.init($("#ContactForm-email"), _THIS.form.find("input[type=submit]"), function(isemailvalid) {
            _THIS.emailhasValidated = isemailvalid;

            /*if($("#Mobile").length <= 0){
                _THIS.phonehasValidated = true;
            }*/

            if (_THIS.emailhasValidated) {
                _THIS.form.find("input[type=submit]").prop("disabled", false)
            }
        })

        if ($("#ContactForm-email").val() !== "") {
            $("#ContactForm-email").trigger("blur")
        }


        /*if($("#Mobile").length > 0){
            $(document).on("focus","#Mobile",function(){
                if($(this).val().length ==0){
                    $(this).val(theme.devSettings.phoneCountryCode)
                }
            })

            var instPhoneValidate = new phoneValidate();
            instPhoneValidate.init("#Mobile",false,_THIS.form.find("input[type=submit]"),function(isphonevalid){
                _THIS.phonehasValidated = isphonevalid;
                if(_THIS.phonehasValidated && _THIS.emailhasValidated){
                    _THIS.form.find("input[type=submit]").prop("disabled",false)
                }
            })	

        }*/




        //
        $(document).on("click", _THIS.formString + " input[type=submit]", function(e) {
            _THIS.submitForm(e);
        })


    }


    this.submitForm = function(e) {


        var validFormResult = _THIS.validateForm();
        e.preventDefault();
        if (!validFormResult.isFormValid) {
            _THIS.displayFormErrors(validFormResult.messages.error)
        } else {
            _THIS.form.submit();

        }
    }


    this.validateForm = function() {

        _THIS.hideFormErrors();

        var retObj = {
            isFormValid: true,
            messages: {
                error: [],
                success: []
            }
        }

        var mandatoryFields = ["#ContactForm-email"]


        for (var i = 0; i < mandatoryFields.length; i++) {
            var fld = _THIS.form.find(mandatoryFields[i])
            var fldVal = fld.val();
            if ($.trim(fldVal).length <= 0) {
                fld.addClass("invalid")
                retObj.isFormValid = false;
            } else {
                fld.removeClass("invalid")
            }
        }


        /*if(_THIS.form.find("#Mobile").length >0 ){
            if(!_THIS.form.find("#Mobile").hasClass("valid")){
                _THIS.form.find("#Mobile").addClass("invalid")
                retObj.isFormValid = false;    
            }
        }*/

        if (!_THIS.form.find("#ContactForm-email").hasClass("valid")) {
            _THIS.form.find("#ContactForm-email").addClass("invalid")
            retObj.isFormValid = false;
        }



        if (!retObj.isFormValid) {
            retObj.messages.error.push(theme.forms.general.mandatory)
        }

        return retObj;
    }

    this.displayFormErrors = function(arrErrors) {

        var htmlErrorList = ""
        for (var i = 0; i < arrErrors.length; i++) {
            htmlErrorList += "<li>" + arrErrors[i] + "</li>"
        }

        if (htmlErrorList !== "") {
            _THIS.form.find(".form-message").removeClass("form-message--error").removeClass("form-message--success")
            _THIS.form.find(".form-message .form-message-inner").html("<ul>" + htmlErrorList + "</ul>")

            _THIS.form.find(".form-message").addClass("form-message--error")
            _THIS.form.find(".form-message").removeClass("hide")

        }
    }

    this.hideFormErrors = function() {
        _THIS.form.find(".form-message").addClass("hide")
        _THIS.form.find(".form-message").removeClass("form-message--error").removeClass("form-message--success")
        _THIS.form.find(".form-message .form-message-inner").html("")
    }


}
/**Commented with New Newsletter Inline Implementation - 09032023 - start */
/*
export function newsletter(){
    
    this.formtype = "rejoiner";
    var _THIS = this;
    this.init = function(){
        if(!theme.newsletter.enabled){return;}

        if (typeof($("#newsletter-template #news-subsc-popup").attr("data-formtype"))!=="undefined"){
            _THIS.formtype = $("#newsletter-template #news-subsc-popup").attr("data-formtype")
        }

        $(document).on("click","#newsletter",function(e){
            e.preventDefault();
            var showNewsletter = true;

            if( _THIS.formtype!=="rejoiner"){
                if(theme.loyalty.enable && !theme.loyalty.maintenance_mode ){

                    showNewsletter = true;
                }else{
                    showNewsletter = false;
                }
            }else{
                showNewsletter = true;
            }

            if(showNewsletter){
                _THIS.displayNewsletterPopup();
            }
            
        })


        $(document).on("click","#newsletter-template input[type=submit]",function(e){
            e.preventDefault();
            if(!$("#newsletter-template #popup-subscribe-newsletter-email").hasClass("valid")){
                $("#newsletter-template #popup-subscribe-newsletter-email").trigger("blur")
            }
        })

        if(theme.newsletter.autoShowSecondPage){
            if(!$(document.body).hasClass("template-index")){
                var autoShowSubscribePopup = Cookies.get("autoShowSubscribePopup");
                if(autoShowSubscribePopup != "false") {
			
                    //Set cookie for next time (14 days)
                    Cookies.set("autoShowSubscribePopup","false",14);
        
                    _THIS.displayNewsletterPopup();			
                }
            }
        }
        
        
    }

    this.submitNewsLetterSubscribe = function(){

        
        var emailStr = $("#newsletter-template #popup-subscribe-newsletter-email").val();
        var subscribeBrand = "";
        if($("body").hasClass("brand-sloggi")){
            subscribeBrand = "sloggi";
        }
        

        if(_THIS.formtype == "rejoiner"){

            if(typeof(_rejoiner)!== 'undefined'){
                _rejoiner.push(['subscribeToList', {
                    email: emailStr,
                    brand: subscribeBrand,
                    list_id: theme.devSettings.rejoinerSubscribeListID,
                    language: (Shopify.locale || '').substr(0, 2)
                }]);
            }

            _THIS.displayThankYouMessage();
        }else{

            var btcheck = "";

            if($("#popup-subscribe-newsletter-email").closest("form").find("input[name='bt_check']").length > 0){
                btcheck  = $("#popup-subscribe-newsletter-email").closest("form").find("input[name='bt_check']").val()
                
            };


            (async () => {
                const { newsletterSubscribe, showFormErrorMessage } = await import(theme.components.loyaltyURL);
                
                newsletterSubscribe(emailStr,btcheck,function(response){
                    if(response !== null){
                        if(response.IsSuccess == true){
                            _THIS.displayThankYouMessage();
                        }else{

                            showFormErrorMessage("#newsletter-template","<ul><li>" +  response.Message + "</li></ul>")

                            $("#news-subsc-popup  input[type=submit]").prop("disabled",false)
                            $("#newsletter-template .form-message").delay(10000).fadeOut(1000,"linear",function(){
                                $("#newsletter-template .form-message").addClass("hide");
                                $("#newsletter-template .form-message").attr("style","")
                            })
                        }   
                    }else{
                        
                        showFormErrorMessage("#newsletter-template","<ul><li>" + theme.loyalty.sys_error_text + "</li></ul>")
                        $("#news-subsc-popup input[type=submit]").prop("disabled",false)

                        $("#newsletter-template .form-message").delay(10000).fadeOut(1000,"linear",function(){
                            $("#newsletter-template .form-message").addClass("hide");
                            $("#newsletter-template .form-message").attr("style","")
                        })
                    }
                    
                })
                
                
            })();

        }
        //console.log("subscribing now...")
    }

    this.displayThankYouMessage = function(){
        $("#newsletter-template #news-subsc-popup .news-subsc-popup-intro").addClass("hide")
        $("#newsletter-template #news-subsc-popup .news-subsc-popup-thankyou").removeClass("hide")

        if (typeof(ga) != "undefined") {
            ga('send', 'event', 'Newsletter', 'Subscribe', 'Popup');
        }
    }

    this.displayNewsletterPopup = function(){


            checkLibrary($.fancybox, theme.components.modalLibraryURL, function(){

                $.fancybox.open('<div id="newsletter-template"><div class="wrap-content"><div class="inner-wrap"><div class="loader-content"><img src="' + theme.loaderImage + '" /></div></div></div></div>',{
                    beforeShow : function( instance, current ) {
                        
                        $.ajax({
                            type: 'GET',
                            
                            url: window.Shopify.routes.root + 'pages/newsletter?view=newsletter',
                            success: function(response) {
                                $("#newsletter-template .inner-wrap").html(response)

                                Cookies.set("autoShowSubscribePopup","false",14);

                                //replace the [form] with form html

                                $("#newsletter-template .news-subsc-popup .form-wrapper").append($("#newsletter-template .news-subsc-popup .form-wrapper-hidden").html())
				                $("#newsletter-template .news-subsc-popup .form-wrapper-hidden").remove();


                                if($("body").hasClass("brand-sloggi")){
                                    $("#newsletter-template .news-subsc-popup-image-sloggi").removeClass("hide")
                                }else{
                                    $("#newsletter-template .news-subsc-popup-image").removeClass("hide")
                                }

                                var instEmailValidate = new emailValidate();
                                instEmailValidate.init($("#newsletter-template #popup-subscribe-newsletter-email"),$("#newsletter-template").find("input[type=submit]"),function(isemailvalid){
                                 
                                    if(isemailvalid){
                                        //$("#newsletter-template").find("input[type=submit]").prop("disabled",false)

                                        _THIS.submitNewsLetterSubscribe();

                                    }else{
                                        //$("#newsletter-template").find("input[type=submit]").prop("disabled",true)
                                    }
                                })


                            },
                            error: function(status) {
                                console.warn( 'ERROR', status );
                            }
                        })
                        
                    }	
                });

            })
     
    }
}*/

/** Newletter with inline form implementation - 02032023 - start */
export function newsletter() {


    this.formtype = "rejoiner";
    this.formInline = 'false';
    var _THIS = this;
    this.init = function() {
        if (!theme.newsletter.enabled) {
            return;
        }
        if ($("#footer-newsletter").attr("data-is-inline") == 'true') {
            return;
        }

        if (typeof($("#newsletter-template #news-subsc-popup").attr("data-formtype")) !== "undefined") {
            _THIS.formtype = $("#newsletter-template #news-subsc-popup").attr("data-formtype")
            _THIS.formInline = $("#newsletter-template #news-subsc-popup").attr("data-form-inline")
        }

        if (_THIS.formInline === 'true') {

            var showNewsletter = true;

            if (_THIS.formtype == "memberson") {
                if (theme.loyalty.enable && !theme.loyalty.maintenance_mode) {

                    showNewsletter = true;
                } else {
                    showNewsletter = false;
                }
            } else {
                showNewsletter = true;
            }

            if (showNewsletter) {
                var instEmailValidate = new emailValidate();
                instEmailValidate.init($('#newsletter-template [type="email"]'), $("#newsletter-template").find("input[type=submit]"), function(isemailvalid) {

                    if (isemailvalid) {
                        //$("#newsletter-template").find("input[type=submit]").prop("disabled",false)

                        _THIS.submitNewsLetterSubscribe();

                    } else {
                        //$("#newsletter-template").find("input[type=submit]").prop("disabled",true)
                    }
                })
            }
        } else {
            $(document).on("click", "#newsletter", function(e) {
                e.preventDefault();
                var showNewsletter = true;

                if (_THIS.formtype == "memberson") {
                    if (theme.loyalty.enable && !theme.loyalty.maintenance_mode) {
                        showNewsletter = true;
                    } else {
                        showNewsletter = false;
                    }
                } else {
                    showNewsletter = true;
                }

                if (showNewsletter) {
                    _THIS.displayNewsletterPopup();
                }

            })
        }




        $(document).on("click", "#newsletter-template input[type=submit]", function(e) {
            e.preventDefault();
            if (!$('#newsletter-template [type="email"]').hasClass("valid")) {
                $('#newsletter-template [type="email"]').trigger("blur")
            }
        })

        if (theme.newsletter.autoShowSecondPage) {
            if (!$(document.body).hasClass("template-index")) {
                var autoShowSubscribePopup = Cookies.get("autoShowSubscribePopup");
                if (autoShowSubscribePopup != "false") {

                    //Set cookie for next time (14 days)
                    Cookies.set("autoShowSubscribePopup", "false", 14);

                    _THIS.displayNewsletterPopup();
                }
            }
        }


    }

    this.submitNewsLetterSubscribe = function() {


        var emailStr = $('#newsletter-template [type="email"]').val();
        var subscribeBrand = "";
        if ($("body").hasClass("brand-sloggi")) {
            subscribeBrand = "sloggi";
        }


        if (_THIS.formtype !== "memberson") {

            /*if(typeof(_rejoiner)!== 'undefined'){
                _rejoiner.push(['subscribeToList', {
                    email: emailStr,
                    brand: subscribeBrand,
                    list_id: theme.devSettings.rejoinerSubscribeListID,
                    language: (Shopify.locale || '').substr(0, 2)
                }]);
            }*/

            //Implement Insider Here
            window.insider_object = window.insider_object || {};
            window.insider_object.user = {
                "gdpr_optin": true,
                "email": emailStr,
                "email_optin": true,
                "language": (Shopify.locale + "-" + Shopify.country).toLowerCase()
            }
            _THIS.displayThankYouMessage();
            /* (async () => {

                const URL = 'https://unification.useinsider.com/api/user/v1/upsert';
                const postData = {};
                postData.users = [];
                postData.users.push(
                {
                    identifiers: {
                    email: emailStr
                    },
                    attributes:{
                        gdpr_optin:true,
                       email_optin: true
                    },
                    not_append:true
                }
                )
     
                const rawResponse = await fetch(URL, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'X-PARTNER-NAME':'triumphhk',
                    'X-REQUEST-TOKEN':'ffa15e359b2546ee0dc99b8cc1da2b0022d6af00c401423988e817bc7c7724'
                },
                body: JSON.stringify(postData)
                });
                const content = await rawResponse.json();
                _THIS.displayThankYouMessage();
            })();*/




        } else {

            var btcheck = "";

            if ($("#popup-subscribe-newsletter-email").closest("form").find("input[name='bt_check']").length > 0) {
                btcheck = $("#popup-subscribe-newsletter-email").closest("form").find("input[name='bt_check']").val()

            };


            (async () => {
                const {
                    newsletterSubscribe,
                    showFormErrorMessage
                } = await import(theme.components.loyaltyURL);
                console.log(`emailStr: ${emailStr}`)
                newsletterSubscribe(emailStr, btcheck, function(response) {
                    if (response !== null) {
                        if (response.IsSuccess == true) {
                            _THIS.displayThankYouMessage();
                        } else {

                            showFormErrorMessage("#newsletter-template", "<ul><li>" + response.Message + "</li></ul>")

                            $("#news-subsc-popup  input[type=submit]").prop("disabled", false)
                            $("#newsletter-template .form-message").delay(10000).fadeOut(1000, "linear", function() {
                                $("#newsletter-template .form-message").addClass("hide");
                                $("#newsletter-template .form-message").attr("style", "")
                            })
                        }
                    } else {

                        showFormErrorMessage("#newsletter-template", "<ul><li>" + theme.loyalty.sys_error_text + "</li></ul>")
                        $("#news-subsc-popup input[type=submit]").prop("disabled", false)

                        $("#newsletter-template .form-message").delay(10000).fadeOut(1000, "linear", function() {
                            $("#newsletter-template .form-message").addClass("hide");
                            $("#newsletter-template .form-message").attr("style", "")
                        })
                    }

                })


            })();

        }
        //console.log("subscribing now...")
    }

    this.displayThankYouMessage = function() {
        $("#newsletter-template #news-subsc-popup .news-subsc-popup-intro").addClass("hide")
        $("#newsletter-template #news-subsc-popup .news-subsc-popup-thankyou").removeClass("hide")

        if (typeof(gtag) != "undefined") {
            //ga('send', 'event', 'Newsletter', 'Subscribe', 'Popup');
            gtag('event', 'Subscribe', {
                'category': 'Newsletter',
                'label': 'Popup'
            })
        }
    }

    this.displayNewsletterPopup = function() {


        checkLibrary($.fancybox, theme.components.modalLibraryURL, function() {

            $.fancybox.open('<div id="newsletter-template"><div class="wrap-content"><div class="inner-wrap"><div class="loader-content"><img src="' + theme.loaderImage + '" /></div></div></div></div>', {
                beforeShow: function(instance, current) {

                    $.ajax({
                        type: 'GET',

                        url: window.Shopify.routes.root + 'pages/newsletter?view=newsletter',
                        success: function(response) {
                            $("#newsletter-template .inner-wrap").html(response)

                            Cookies.set("autoShowSubscribePopup", "false", 14);

                            //replace the [form] with form html

                            $("#newsletter-template .news-subsc-popup .form-wrapper").append($("#newsletter-template .news-subsc-popup .form-wrapper-hidden").html())
                            $("#newsletter-template .news-subsc-popup .form-wrapper-hidden").remove();


                            if ($("body").hasClass("brand-sloggi")) {
                                $("#newsletter-template .news-subsc-popup-image-sloggi").removeClass("hide")
                            } else {
                                $("#newsletter-template .news-subsc-popup-image").removeClass("hide")
                            }

                            var instEmailValidate = new emailValidate();
                            instEmailValidate.init($("#newsletter-template #popup-subscribe-newsletter-email"), $("#newsletter-template").find("input[type=submit]"), function(isemailvalid) {

                                if (isemailvalid) {
                                    //$("#newsletter-template").find("input[type=submit]").prop("disabled",false)

                                    _THIS.submitNewsLetterSubscribe();

                                } else {
                                    //$("#newsletter-template").find("input[type=submit]").prop("disabled",true)
                                }
                            })


                        },
                        error: function(status) {
                            console.warn('ERROR', status);
                        }
                    })

                }
            });

        })

    }

    /**POPUP */
    this.submitNewsLetterSubscribePopUp = function() {


        var emailStr = $("#newsletter-template #popup-subscribe-newsletter-email").val();
        var subscribeBrand = "";
        if ($("body").hasClass("brand-sloggi")) {
            subscribeBrand = "sloggi";
        }
        var formType = $("#newsletter-template #news-subsc-popup").attr("data-formtype")

        if (formType !== "memberson") {

            /*if(typeof(_rejoiner)!== 'undefined'){
                _rejoiner.push(['subscribeToList', {
                    email: emailStr,
                    brand: subscribeBrand,
                    list_id: theme.devSettings.rejoinerSubscribeListID,
                    language: (Shopify.locale || '').substr(0, 2)
                }]);
            }*/

            //Implement Insider Here
            window.insider_object = window.insider_object || {};
            window.insider_object.user = {
                "gdpr_optin": true,
                "email": emailStr,
                "email_optin": true,
                "language": (Shopify.locale + "-" + Shopify.country).toLowerCase()
            }

            _THIS.displayThankYouMessagePopUp();

            /* (async () => {

                const URL = 'https://unification.useinsider.com/api/user/v1/upsert';
                const postData = {};
                postData.users = [];
                postData.users.push(
                {
                    identifiers: {
                    email: emailStr
                    },
                    attributes:{
                    gdpr_optin:true,
                       email_optin: true
                    },
                    not_append:true
                }
                )
     
                const rawResponse = await fetch(URL, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'X-PARTNER-NAME':'triumphhk',
                    'X-REQUEST-TOKEN':'ffa15e359b2546ee0dc99b8cc1da2b0022d6af00c401423988e817bc7c7724'
                },
                body: JSON.stringify(postData)
                });
                const content = await rawResponse.json();
                _THIS.displayThankYouMessagePopUp();
            })();*/



        } else {

            var btcheck = "";

            if ($("#popup-subscribe-newsletter-email").closest("form").find("input[name='bt_check']").length > 0) {
                btcheck = $("#popup-subscribe-newsletter-email").closest("form").find("input[name='bt_check']").val()

            };


            (async () => {
                const {
                    newsletterSubscribe,
                    showFormErrorMessage
                } = await import(theme.components.loyaltyURL);

                newsletterSubscribe(emailStr, btcheck, function(response) {
                    if (response !== null) {
                        if (response.IsSuccess == true) {
                            _THIS.displayThankYouMessagePopUp();
                        } else {

                            showFormErrorMessage("#news-subsc-popup", "<ul><li>" + response.Message + "</li></ul>")

                            $("#news-subsc-popup  input[type=submit]").prop("disabled", false)
                            $("#news-subsc-popup .form-message").delay(10000).fadeOut(1000, "linear", function() {
                                $("#news-subsc-popup .form-message").addClass("hide");
                                $("#news-subsc-popup .form-message").attr("style", "")
                            })
                        }
                    } else {

                        showFormErrorMessage("#news-subsc-popup", "<ul><li>" + theme.loyalty.sys_error_text + "</li></ul>")
                        $("#news-subsc-popup input[type=submit]").prop("disabled", false)

                        $("#news-subsc-popup .form-message").delay(10000).fadeOut(1000, "linear", function() {
                            $("#news-subsc-popup .form-message").addClass("hide");
                            $("#news-subsc-popup .form-message").attr("style", "")
                        })
                    }

                })


            })();

        }
        //console.log("subscribing now...")
    }
    this.displayThankYouMessagePopUp = function() {
        $("#news-subsc-popup .news-subsc-popup-intro").addClass("hide")
        $("#news-subsc-popup .news-subsc-popup-thankyou").removeClass("hide")

        if (typeof(gtag) != "undefined") {
            //ga('send', 'event', 'Newsletter', 'Subscribe', 'Popup');
            gtag('event', 'Subscribe', {
                'category': 'Newsletter',
                'label': 'Popup'
            })
        }
    }
    this.displayNewsletterPopup = function() {


        checkLibrary($.fancybox, theme.components.modalLibraryURL, function() {

            $.fancybox.open('<div id="newsletter-template"><div class="wrap-content"><div class="inner-wrap"><div class="loader-content"><img src="' + theme.loaderImage + '" /></div></div></div></div>', {
                beforeShow: function(instance, current) {

                    $.ajax({
                        type: 'GET',

                        url: window.Shopify.routes.root + 'pages/newsletter?view=newsletter',
                        success: function(response) {
                            $("#newsletter-template .inner-wrap").html(response)

                            Cookies.set("autoShowSubscribePopup", "false", 14);

                            //replace the [form] with form html

                            $("#newsletter-template .news-subsc-popup .form-wrapper").append($("#newsletter-template .news-subsc-popup .form-wrapper-hidden").html())
                            $("#newsletter-template .news-subsc-popup .form-wrapper-hidden").remove();


                            if ($("body").hasClass("brand-sloggi")) {
                                $("#newsletter-template .news-subsc-popup-image-sloggi").removeClass("hide")
                            } else {
                                $("#newsletter-template .news-subsc-popup-image").removeClass("hide")
                            }

                            var instEmailValidate = new emailValidate();
                            instEmailValidate.init($("#newsletter-template #popup-subscribe-newsletter-email"), $("#newsletter-template").find("input[type=submit]"), function(isemailvalid) {

                                if (isemailvalid) {
                                    //$("#newsletter-template").find("input[type=submit]").prop("disabled",false)

                                    _THIS.submitNewsLetterSubscribePopUp();

                                } else {
                                    //$("#newsletter-template").find("input[type=submit]").prop("disabled",true)
                                }
                            })


                        },
                        error: function(status) {
                            console.warn('ERROR', status);
                        }
                    })

                }
            });

        })

    }


}

export function newsletterInline() {

    this.formtype = "rejoiner";
    this.formInline = 'false';
    var _THIS = this;
    this.init = function() {
        if (!theme.newsletter.enabled) {
            return;
        }
        if ($("#footer-newsletter").attr("data-is-inline") == 'false') {
            return;
        }

        if (typeof($("#newsletter-template-inline #news-subsc-popup-inline").attr("data-formtype")) !== "undefined") {
            _THIS.formtype = $("#newsletter-template-inline #news-subsc-popup-inline").attr("data-formtype")
            _THIS.formInline = $("#newsletter-template-inline #news-subsc-popup-inline").attr("data-form-inline")
        }

        if (_THIS.formInline === 'true') {
            var showNewsletter = true;
            if (_THIS.formtype == "memberson") {
                if (theme.loyalty.enable && !theme.loyalty.maintenance_mode) {
                    showNewsletter = true;
                } else {
                    showNewsletter = false;
                }
            } else {
                showNewsletter = true;
            }



            if (showNewsletter) {
                var instEmailValidate = new emailValidate();
                instEmailValidate.init($('#newsletter-template-inline [type="email"]'), $("#newsletter-template-inline").find("input[type=submit]"), function(isemailvalid) {

                    if (isemailvalid) {
                        //$("#newsletter-template").find("input[type=submit]").prop("disabled",false)

                        _THIS.submitNewsLetterSubscribe();

                    } else {
                        //$("#newsletter-template").find("input[type=submit]").prop("disabled",true)
                    }
                })
            }
        } else {
            $(document).on("click", "#newsletter", function(e) {
                e.preventDefault();
                var showNewsletter = true;

                if (_THIS.formtype == "memberson") {
                    if (theme.loyalty.enable && !theme.loyalty.maintenance_mode) {
                        showNewsletter = true;
                    } else {
                        showNewsletter = false;
                    }
                } else {
                    showNewsletter = true;
                }

                if (showNewsletter) {
                    _THIS.displayNewsletterPopup();
                }

            })
        }




        $(document).on("click", "#newsletter-template-inline input[type=submit]", function(e) {
            e.preventDefault();
            if (!$('#newsletter-template-inline [type="email"]').hasClass("valid")) {
                $('#newsletter-template-inline [type="email"]').trigger("blur")
            }
        })

        if (theme.newsletter.autoShowSecondPage) {
            if (!$(document.body).hasClass("template-index")) {
                var autoShowSubscribePopup = Cookies.get("autoShowSubscribePopup");
                if (autoShowSubscribePopup != "false") {

                    //Set cookie for next time (14 days)
                    Cookies.set("autoShowSubscribePopup", "false", 14);

                    _THIS.displayNewsletterPopup();
                }
            }
        }


    }

    this.submitNewsLetterSubscribe = function() {


        var emailStr = $('#newsletter-template-inline [type="email"]').val();
        var subscribeBrand = "";
        if ($("body").hasClass("brand-sloggi")) {
            subscribeBrand = "sloggi";
        }




        if (_THIS.formtype !== "memberson") {

            /*if(typeof(_rejoiner)!== 'undefined'){
                _rejoiner.push(['subscribeToList', {
                    email: emailStr,
                    brand: subscribeBrand,
                    list_id: theme.devSettings.rejoinerSubscribeListID,
                    language: (Shopify.locale || '').substr(0, 2)
                }]);
            }*/

            window.insider_object = window.insider_object || {};
            window.insider_object.user = {
                "gdpr_optin": true,
                "email": emailStr,
                "email_optin": true,
                "language": (Shopify.locale + "-" + Shopify.country).toLowerCase()
            }
            _THIS.displayThankYouMessage();


            //Implement Insider Here

            /* (async () => {

                const URL = 'https://unification.useinsider.com/api/user/v1/upsert';
                const postData = {};
                postData.users = [];
                postData.users.push(
                {
                    identifiers: {
                    email: emailStr
                    },
                    attributes:{
                        gdpr_optin:true,
                       email_optin: true
                    },
                    not_append:true
                }
                )
     
                const rawResponse = await fetch(URL, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'X-PARTNER-NAME':'triumphhk',
                    'X-REQUEST-TOKEN':'ffa15e359b2546ee0dc99b8cc1da2b0022d6af00c401423988e817bc7c7724'
                },
                body: JSON.stringify(postData)
                });
                const content = await rawResponse.json();
                _THIS.displayThankYouMessage();
            })();*/




        } else {

            var btcheck = "";

            if ($("#popup-subscribe-newsletter-email").closest("form").find("input[name='bt_check']").length > 0) {
                btcheck = $("#popup-subscribe-newsletter-email").closest("form").find("input[name='bt_check']").val()

            };


            (async () => {
                const {
                    newsletterSubscribe,
                    showFormErrorMessage
                } = await import(theme.components.loyaltyURL);

                newsletterSubscribe(emailStr, btcheck, function(response) {
                    if (response !== null) {
                        if (response.IsSuccess == true) {

                            _THIS.displayThankYouMessage();
                        } else {

                            showFormErrorMessage("#newsletter-template-inline", "<ul><li>" + response.Message + "</li></ul>")

                            $("#news-subsc-popup-inline  input[type=submit]").prop("disabled", false)
                            $("#newsletter-template-inline .form-message").delay(10000).fadeOut(1000, "linear", function() {
                                $("#newsletter-template-inline .form-message").addClass("hide");
                                $("#newsletter-template-inline .form-message").attr("style", "")
                            })
                        }
                    } else {

                        showFormErrorMessage("#newsletter-template-inline", "<ul><li>" + theme.loyalty.sys_error_text + "</li></ul>")
                        $("#news-subsc-popup-inline input[type=submit]").prop("disabled", false)

                        $("#newsletter-template-inline .form-message").delay(10000).fadeOut(1000, "linear", function() {
                            $("#newsletter-template-inline .form-message").addClass("hide");
                            $("#newsletter-template-inline .form-message").attr("style", "")
                        })
                    }

                })


            })();

        }
        //console.log("subscribing now...")
    }

    this.displayThankYouMessage = function() {
        $("#newsletter-template-inline #news-subsc-popup-inline .news-subsc-popup-intro").addClass("hide")
        $("#newsletter-template-inline #news-subsc-popup-inline .news-subsc-popup-thankyou").removeClass("hide")

        if (typeof(gtag) != "undefined") {
            //ga('send', 'event', 'Newsletter', 'Subscribe', 'Popup');
            gtag('event', 'Subscribe', {
                'category': 'Newsletter',
                'label': 'Popup'
            })
        }
    }

    /**POPUP */
    this.submitNewsLetterSubscribePopUp = function() {


        var emailStr = $("#newsletter-template #popup-subscribe-newsletter-email").val();
        var subscribeBrand = "";
        if ($("body").hasClass("brand-sloggi")) {
            subscribeBrand = "sloggi";
        }
        var formType = $("#newsletter-template #news-subsc-popup").attr("data-formtype")

        //if(formType == "rejoiner"){
        if (formType !== "memberson") {
            /*if(typeof(_rejoiner)!== 'undefined'){
                _rejoiner.push(['subscribeToList', {
                    email: emailStr,
                    brand: subscribeBrand,
                    list_id: theme.devSettings.rejoinerSubscribeListID,
                    language: (Shopify.locale || '').substr(0, 2)
                }]);
            }*/

            window.insider_object = window.insider_object || {};
            window.insider_object.user = {
                "gdpr_optin": true,
                "email": emailStr,
                "email_optin": true,
                "language": (Shopify.locale + "-" + Shopify.country).toLowerCase()
            }
            _THIS.displayThankYouMessagePopUp();

            //Implement Insider Here

            /*(async () => {

                const URL = 'https://unification.useinsider.com/api/user/v1/upsert';
                const postData = {};
                postData.users = [];
                postData.users.push(
                {
                    identifiers: {
                    email: emailStr
                    },
                    attributes:{
                        gdpr_optin:true,
                       email_optin: true
                    },
                    not_append:true
                }
                )
     
                const rawResponse = await fetch(URL, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'X-PARTNER-NAME':'triumphhk',
                    'X-REQUEST-TOKEN':'ffa15e359b2546ee0dc99b8cc1da2b0022d6af00c401423988e817bc7c7724'
                },
                body: JSON.stringify(postData)
                });
                const content = await rawResponse.json();
                _THIS.displayThankYouMessagePopUp();
            })();*/



        } else {

            var btcheck = "";

            if ($("#popup-subscribe-newsletter-email").closest("form").find("input[name='bt_check']").length > 0) {
                btcheck = $("#popup-subscribe-newsletter-email").closest("form").find("input[name='bt_check']").val()

            };


            (async () => {
                const {
                    newsletterSubscribe,
                    showFormErrorMessage
                } = await import(theme.components.loyaltyURL);

                newsletterSubscribe(emailStr, btcheck, function(response) {
                    if (response !== null) {
                        if (response.IsSuccess == true) {
                            _THIS.displayThankYouMessagePopUp();
                        } else {

                            showFormErrorMessage("#news-subsc-popup", "<ul><li>" + response.Message + "</li></ul>")

                            $("#news-subsc-popup  input[type=submit]").prop("disabled", false)
                            $("#news-subsc-popup .form-message").delay(10000).fadeOut(1000, "linear", function() {
                                $("#news-subsc-popup .form-message").addClass("hide");
                                $("#news-subsc-popup .form-message").attr("style", "")
                            })
                        }
                    } else {

                        showFormErrorMessage("#news-subsc-popup", "<ul><li>" + theme.loyalty.sys_error_text + "</li></ul>")
                        $("#news-subsc-popup input[type=submit]").prop("disabled", false)

                        $("#news-subsc-popup .form-message").delay(10000).fadeOut(1000, "linear", function() {
                            $("#news-subsc-popup .form-message").addClass("hide");
                            $("#news-subsc-popup .form-message").attr("style", "")
                        })
                    }

                })


            })();

        }
        //console.log("subscribing now...")
    }
    this.displayThankYouMessagePopUp = function() {
        $("#news-subsc-popup .news-subsc-popup-intro").addClass("hide")
        $("#news-subsc-popup .news-subsc-popup-thankyou").removeClass("hide")

        if (typeof(gtag) != "undefined") {
            //ga('send', 'event', 'Newsletter', 'Subscribe', 'Popup');
            gtag('event', 'Subscribe', {
                'category': 'Newsletter',
                'label': 'Popup'
            })
        }
    }
    this.displayNewsletterPopup = function() {


        checkLibrary($.fancybox, theme.components.modalLibraryURL, function() {

            $.fancybox.open('<div id="newsletter-template"><div class="wrap-content"><div class="inner-wrap"><div class="loader-content"><img src="' + theme.loaderImage + '" /></div></div></div></div>', {
                beforeShow: function(instance, current) {

                    $.ajax({
                        type: 'GET',

                        url: window.Shopify.routes.root + 'pages/newsletter?view=newsletter',
                        success: function(response) {
                            $("#newsletter-template .inner-wrap").html(response)

                            Cookies.set("autoShowSubscribePopup", "false", 14);

                            //replace the [form] with form html

                            $("#newsletter-template .news-subsc-popup .form-wrapper").append($("#newsletter-template .news-subsc-popup .form-wrapper-hidden").html())
                            $("#newsletter-template .news-subsc-popup .form-wrapper-hidden").remove();


                            if ($("body").hasClass("brand-sloggi")) {
                                $("#newsletter-template .news-subsc-popup-image-sloggi").removeClass("hide")
                            } else {
                                $("#newsletter-template .news-subsc-popup-image").removeClass("hide")
                            }

                            var instEmailValidate = new emailValidate();
                            instEmailValidate.init($("#newsletter-template #popup-subscribe-newsletter-email"), $("#newsletter-template").find("input[type=submit]"), function(isemailvalid) {

                                if (isemailvalid) {
                                    //$("#newsletter-template").find("input[type=submit]").prop("disabled",false)

                                    _THIS.submitNewsLetterSubscribePopUp();

                                } else {
                                    //$("#newsletter-template").find("input[type=submit]").prop("disabled",true)
                                }
                            })


                        },
                        error: function(status) {
                            console.warn('ERROR', status);
                        }
                    })

                }
            });

        })

    }

}
/** Newletter with inline form implementation - 02032023 - end */

/** Main Menu Activation  */
export function menu() {
    this.init = function() {
        var instHeadMiniCart = new miniCart();
        var instMyAccountHeader = new myAccountHeader();
        var instPromtoionHeader = new promotionHeader();

        instPromtoionHeader.init();

        $(document).on("click", "li.iconbag-item", function(e) {
            e.preventDefault();

            if (!$(document.body).hasClass("template-cart")) {
                if ($(this).hasClass("has-items")) {

                    instHeadMiniCart.init();
                    instHeadMiniCart.toggleDisplayMiniCart();
                }
            }
        })

        $(document).on("click", "li.iconuser-item", function(e) {

            if ($(this).hasClass("is-loggedin")) {
                return true; //goes to my account landing
            } else {


                //We check if the login Account is already on the page then we do nothing
                //for example on the login page


                //if loyalty sistem is enabled and active we show the dropdown
                //else we direct to login page (for shop)   



                if ($(".main-login #customer_login").length > 0) {
                    return;
                }


                if (!theme.loyalty.enable) {
                    return true;
                } else {
                    if (theme.loyalty.maintenance_mode == false) {
                        e.preventDefault();
                    }
                }



                if ($("body").hasClass("myaccount-login-active")) {
                    instMyAccountHeader.hideLoginForm();
                } else {


                    instMyAccountHeader.showLoginForm();


                    if ($("#myaccount-login #customer_login").length <= 0) {
                        instMyAccountHeader.loadLoginForm(function(content) {
                            $("#myaccount-login-inner-wrapper").html(content['header-login-content']);

                            (async () => {
                                const {
                                    myAccountLogin
                                } = await import(theme.components.myAccountURL);
                                let instMyAccount = new myAccountLogin();
                                instMyAccount.init();

                            })();



                        })
                    } else {
                        instMyAccountHeader.resetLoginForm();
                    }

                }
            }
        })


        $("#added-product #added-product-close, #added-product #added-product-continue-mob, #added-product #added-product-continue, #added-product .added-product-overlay").click(function(e) {
            e.preventDefault();
            $("#added-product").toggleClass("active");
            $("body").toggleClass("added-product-active");
        })

        $("#myaccount-login #myaccount-login-close, #myaccount-login .myaccount-login-overlay").click(function(e) {
            e.preventDefault();

            $("#myaccount-login").toggleClass("active");
            $("body").toggleClass("myaccount-login-active");
        })



        $("#site-search, #search-dropdown #search-close, #search-dropdown .search-overlay").click(function() {
            if ($("body").hasClass("menu-active")) {
                $("#shop-menu").click();
            }
            if ($("body").hasClass("myaccount-login-active")) {
                instMyAccountHeader.hideLoginForm();
            }

            if ($("body").hasClass("added-product-active")) {
                $("body").removeClass("added-product-active")
                $("#added-product").removeClass("active");
            }



            $("body").toggleClass("search-active");
            $("#search-dropdown").toggleClass("active");
            $("body").addClass("search-activated");
            /*if(!$("#search-dropdown").hasClass("active")){
                $("#search-dropdown").removeClass("search-performed")
            }*/

            var detSearchTime = new detectSearchActivation(800)
        });


        $("#shop-menu, #main-menu #menu-close, #main-menu .menu-overlay").click(function() {
            if ($("body").hasClass("search-active")) {
                $("#site-search").click();
            }

            if ($("body").hasClass("myaccount-login-active")) {
                instMyAccountHeader.hideLoginForm();
            }
            if ($("body").hasClass("added-product-active")) {
                $("body").removeClass("added-product-active")
                $("#added-product").removeClass("active");
            }



            $("#main-menu").toggleClass("active");
            $("#main-menu").find(".active-menu").removeClass("active-menu");
            $(this).removeClass("active");
            $("body").toggleClass("menu-active");
            $("#menu-root").find(".active-sub-menu-item").removeClass("active-sub-menu-item");
            $("#menu-root").find(".active-sub-menu").removeClass("active-sub-menu");
            $("#menu-back").removeClass("active");
        });

        /*$("#menu-root a").hover(
          function(e){
            var attr = $(this).parent().attr("data-menu");
            $("#main-menu").find(".active-sub-menu-item").removeClass("active-sub-menu-item");
            if (typeof attr !== typeof undefined && attr !== false) {
                e.preventDefault();
                $("#main-menu").find(".active-menu").removeClass("active-menu");
                $("#main-menu").find($("#" + attr + "-menu")).addClass("active-menu");
                $("#menu-back").addClass("active");
                $("#menu-back .sub-title").text($(this).text());
                $(this).parent().addClass("active-sub-menu-item").parent().addClass("active-sub-menu");
            }
          },
          function(e){
            $("#main-menu").find(".active-menu").removeClass("active-menu");
          }
        )*/


        var menuHover = function(isShow) {
            if (!$("#mobile-menu").is(":visible")) {

                var attr = $(this).attr("data-menu");

                if (attr) {
                    $("#main-menu").addClass("active");
                    $(this).addClass("active")
                    $("#" + attr + "-menu").addClass("active-menu");

                }

            }
        }


        var menuHoverOut = function(isShow) {
            if (!$("#mobile-menu").is(":visible")) {

                var attr = $(this).attr("data-menu");

                if (attr) {
                    $("#main-menu").removeClass("active");
                    $(this).removeClass("active")
                    $("#" + attr + "-menu").removeClass("active-menu");

                }

            }
        }

        $("#menu-root > ul > li").hover(menuHover, menuHoverOut);

        $("#menu-root .root-menu-item").on("click", function(e) {
            if ($("#mobile-menu").is(":visible")) {
                if ($(this).parent().attr("data-menu")) {
                    e.preventDefault();
                    e.stopPropagation();

                    $("#main-menu").addClass("active")
                    $(this).parent().find(".shop-sub-items").addClass("active-menu")
                    return
                }
            }
            var subscribeBrand = "Triumph";
            if ($("body").hasClass("brand-sloggi")) {
                subscribeBrand = "Sloggi";
            }
                let curMenuText = $(this).text().trim();
                if(curMenuText == ""){
                    curMenuText = ($(this).find('img'))?$(this).find('img').attr("alt"):"";   
                }
            let menuCategory = subscribeBrand + " - Main Menu";
            sendGTAForMenu(menuCategory, curMenuText);
        })

        $("#menu-root .shop-sub-items .menu-items li").on("click", function(e) {
            var subscribeBrand = "Triumph";
            if ($("body").hasClass("brand-sloggi")) {
                subscribeBrand = "Sloggi";
            }
            let parentMenu = $(this).parents(".shop-sub-items").attr("data-sub-menu");
            let parentMenuItem = $("li[data-menu='" + parentMenu + "']").find(".root-menu-item").text();
                let curMenuText = parentMenuItem+" - "+$(this).text().trim();
                if($(this).text().trim() == ""){
                    curMenuText = ($(this).find('img'))?parentMenuItem+" - "+$(this).find('img').attr("alt"):"";   
                } 
            let menuCategory = subscribeBrand + " - Main Menu";
            sendGTAForMenu(menuCategory, curMenuText);
        });


        $(".menu-back").click(function() {
            $(this).removeClass("active");
            $("#menu-root").find(".active-sub-menu-item").removeClass("active-sub-menu-item");
            $("#menu-root").find(".active-sub-menu").removeClass("active-sub-menu");
            $("#main-menu").find(".active-menu").removeClass("active-menu");
        })


        //detecting which menu item is being hovered on page load
        if (document.querySelector("#menu-root:hover")) {
            if (!$("#mobile-menu").is(":visible")) {
                $("#main-menu").addClass("active");
            }

            $("#menu-root li[data-menu]:hover").each(function() {
                if ($(this)) {
                    $(this).addClass("active")
                    $(this).find(".shop-sub-items").addClass("active-menu")
                }

            })

        }
    }




    /* Open all links in new tab if not same domain */
    var links = document.links;
    for (let i = 0, linksLength = links.length; i < linksLength; i++) {
        if (links[i].hostname !== window.location.hostname) {
            if (links[i].href.toLowerCase().indexOf('javascript:') == -1) {
                links[i].target = '_blank';
            }
        }
    }



}

/* Promtion Bar */
export function promotionHeader() {

    var _THIS = this;

    this.init = function() {

        _THIS.registerEvents();

    }

    this.registerEvents = function() {

        $("#promotion-bar #mobile-slide-tab").click(function() {
            $("#promotion-bar").toggleClass("active")
        });

        $("span.more-details").click(function() {
            var popupID = $(this).attr("data-popup");
            $("#" + popupID).addClass("active");
        });

        $(".promotion-popup-close, .promotion-popup-overlay").click(function() {
            $(this).closest(".promotion-popup").removeClass("active");
        });

    }

}


/** CountDown Timer */

export function countDownTimer() {
    var _THIS = this;

    this.timezoneinfo = null;
    this.init = function() {
        $(".countdownContainer").each(function() {

            if (!$(this).hasClass("initialised")) {
                $(this).addClass("initialised")
                _THIS.populateCounter($(this))
            }
        })
    }

    this.populateCounter = function(elem) {
        elem.hide().addClass("hide");

        var cdmessage = elem.attr("data-countdown-message");
        var aftercdmessage = elem.attr("data-countdown-message-after");
        var expiremessage = elem.attr("data-expired-message");

        var premessage = elem.attr("data-pre-countdown-message");
        var postmessage = elem.attr("data-post-countdown-message");


        var durationMinutes = elem.attr("data-duration-minutes");
        var expiration = elem.attr("data-expiry");
        //console.log(expiration)
        if (!expiration) {
            //console.log("a")
            return;
        }


        var _second = 1000;
        var _minute = _second * 60;
        var _hour = _minute * 60;
        var _day = _hour * 24;
        var timer;

        var options = {
            timeZone: theme.devSettings.regional,
            month: 'numeric',
            day: 'numeric',
            year: 'numeric',
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit"
        };

        //var currentBrisbaneTime = nsCountDown.timezoneinfo;
        //var currentBrisbaneTime = new Date().toLocaleDateString(theme.devSettings.language, options);
        try {
            var currentBrisbaneTime = new Date().toLocaleDateString(theme.devSettings.language, options);
            var utc = new Intl.DateTimeFormat(theme.devSettings.language, {
                timeZone: theme.devSettings.regional,
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit"
            });

        } catch (err) {
            //console.log("err" + err)
            return;
        }

        var end = new Date(expiration)

        //set the start date
        var start = new Date(expiration)
        start.setMinutes(start.getMinutes() - durationMinutes);

        //console.log(start)        
        //console.log(end)        

        //Convert the Date String into a valid date object
        //The date string value is DD/MM/YY, need to change to MM/DD/YY 
        //so that the date conversion does not return Invalid date

        var arrBrisTime = currentBrisbaneTime.split(",")
        //console.log("arrBrisTime" + arrBrisTime)
        if (arrBrisTime.length >= 2) {

            var datePart = arrBrisTime[0]
            var arrBrisDate = datePart.split("/")
            var daypart = arrBrisDate[0]
            var monthpart = arrBrisDate[1]
            var yearpart = arrBrisDate[2]

            var newStringBrisTime = monthpart + '/' + daypart + '/' + yearpart;
            var newFullStringBrisTime = newStringBrisTime + ',' + arrBrisTime[1];
            //console.log(newFullStringBrisTime)

            var currentBrisDate = new Date(newFullStringBrisTime);
            if (!(currentBrisDate instanceof Date && !isNaN(currentBrisDate))) {
                var currentBrisDate = new Date(currentBrisbaneTime);
            }

        } else {
            return
        }



        //console.log(currentBrisDate)
        //console.log(start)        
        //console.log(end)        


        //Now Check if the current Time is within the Range to show the countdown
        var withinRange = false

        if (currentBrisDate > start && currentBrisDate < end) {
            withinRange = true;
        }

        //console.log("withinRange" + withinRange)
        if (!withinRange) {

            if (currentBrisDate < start) {

                if (premessage) {
                    elem.html('<span class="nscountdown-message pre">' + premessage + '</span>')
                    elem.show().removeClass("hide");
                }
            }

            if (currentBrisDate > end) {
                if (postmessage) {

                    elem.html('<span class="nscountdown-message post">' + postmessage + '</span>')
                    elem.show().removeClass("hide");
                }
            }

            return
        }


        if (cdmessage) {
            elem.append('<span class="nscountdown-message">' + cdmessage + '</span>')
        }

        elem.append('<span class="nscountdown-timer"></span>')

        if (aftercdmessage) {
            elem.find(".nscountdown-timer").after('<span class="nscountdown-message nscountdown-message-after">' + aftercdmessage + '</span>')
        }

        var now = currentBrisDate;
        var timer = setInterval(function() {


            var distance = end - now - _THIS.getESTOffset(end) * _hour;
            //console.log(distance)
            if (distance < 0) {

                clearInterval(timer);
                if (expiremessage) {
                    elem.html(expiremessage);
                } else {
                    elem.html("").hide();
                }


                return;
            }
            var days = Math.floor(distance / _day);
            var hours = Math.floor((distance % _day) / _hour);
            var minutes = Math.floor((distance % _hour) / _minute);
            var seconds = Math.floor((distance % _minute) / _second);

            var timeHTML = ""

            if (days > 0) {
                timeHTML += '<span class="wrapcountdowneleminfo days"><span class="countdownvalue">' + _THIS.pad(days, 2) + '</span><span class="countdownlabel"> ' + (days > 1 ? theme.strings.countDownTimer.daysLabel : theme.strings.countDownTimer.dayLabel) + ' </span></span>';
            }

            timeHTML += '<span class="wrapcountdowneleminfo hours"><span class="countdownvalue">' + _THIS.pad(hours, 2) + '</span><span class="countdownlabel">:</span></span>';
            timeHTML += '<span class="wrapcountdowneleminfo minutes"><span class="countdownvalue">' + _THIS.pad(minutes, 2) + '</span><span class="countdownlabel">:</span></span>';
            timeHTML += '<span class="wrapcountdowneleminfo seconds"><span class="countdownvalue">' + _THIS.pad(seconds, 2) + '</span><span class="countdownlabel"></span></span>';

            elem.find(".nscountdown-timer").html(timeHTML)
            if (elem.hasClass("hide")) {
                elem.removeClass("hide").show();

            }


            now = currentBrisDate.setSeconds(currentBrisDate.getSeconds() + 1);

        }, 1000);


    }


    this.pad = function(val, size) {
        var sign = Math.sign(val) === -1 ? '-' : '';
        return sign + new Array(size).concat([Math.abs(val)]).join('0').slice(-size);
    }

    this.getESTOffset = function(end) {

        return new Date().getTimezoneOffset() - (end.getTimezoneOffset())
    }


}




/** My Account Header */

export function myAccountHeader() {

    var _THIS = this;


    this.loadLoginForm = function(callback) {
        $.getJSON(window.Shopify.routes.root + '?sections=header-login-content', function(logincontent) {
            _THIS.initLoginForm();
            if (callback != null) return callback.call(this, logincontent);
        })
    }

    this.showLoginForm = function() {

        if ($("body").hasClass("menu-active")) {
            $("#shop-menu").click();
        }

        if ($("body").hasClass("search-active")) {
            $("#site-search").click();
        }


        if ($("body").hasClass("added-product-active")) {
            $("body").removeClass("added-product-active")
            $("#added-product").removeClass("active");
        }


        $("#myaccount-login").addClass("active");
        $("body").addClass("myaccount-login-active");
    }

    this.hideLoginForm = function() {
        $("#myaccount-login").removeClass("active");
        $("body").removeClass("myaccount-login-active");
    }

    this.initLoginForm = function() {
        //Register Login Form Events

        /*$(document).on("click","#myaccount-login #customer_login input[type=submit]",function(e){


            e.preventDefault();
            _THIS.submitLoginForm();
            
        })*/
    }


    this.submitLoginForm = function() {

        var data = {
            'customer[email]': $("#myaccount-login #CustomerEmail").val(),
            'customer[password]': $("#myaccount-login #CustomerPassword").val(),
            form_type: 'customer_login',
            utf8: '✓'
        };

        var promise = $.ajax({
            url: window.Shopify.routes.root + 'account/login',
            method: 'post',
            data: data,
            dataType: 'html',
            async: true
        });


        promise.done(function(html) {
            console.log(html)
            /*if (html.indexOf('Invalid login credentials') !== -1) {
              // invalid password - show a message to the user
            } else {
              
              // All good! Let's redirect if required
              var checkoutUrl = getCheckoutUrl();
              if (checkoutUrl) {
                window.location.href = checkoutUrl;
              } else {
                // don't need to redirect, do what you like! 
              }
              
            }*/
        });


    }

    this.resetLoginForm = function() {

    }


}

/** Site Search */
export function siteSearch() {
    var _THIS = this;

    this.element = null;
    this.currentAjaxRequest = null;
    this.searchTerm = "";
    this.searchURL = window.Shopify.routes.root + 'search/';
    this.init = function(elem) {
        _THIS.element = elem;
        //console.log(_THIS.elementContainer)
        registerEvents()
    }

    var registerEvents = function() {
        $(document).on("keyup change", _THIS.element, function(e) {
            e.preventDefault();

            if (!$("#search-dropdown").hasClass("search-performed")) {
                $("#search-dropdown").addClass("search-performed")
            }

            _THIS.searchTerm = $(this).val();

            if ($(this).val() !== "") {
                _THIS.getSearchResults()
            } else {
                _THIS.clearSearchResults();
            }

        })
    }

    this.getSearchResults = function() {

        if ($.trim(_THIS.searchTerm).length <= 0) {
            _THIS.clearSearchResults();
            return;
        }

        if (_THIS.currentAjaxRequest != null) _THIS.currentAjaxRequest.abort();


        _THIS.currentAjaxRequest = $.getJSON(_THIS.searchURL + `?q=${encodeURIComponent( _THIS.searchTerm )}&view=json`, function(data) {
            _THIS.renderSearchResults(data);
        })

        /*fetch('/search/' + `?q=${encodeURIComponent(searchTerm)}&view=json`)
        .then((response) => {
            if (!response.ok) {
            var error = new Error(response.status);
            throw error;
            }

            return response.text();
        })
        .then((text) => {
            const htmlResult = new DOMParser().parseFromString(text, 'text/html').querySelector('#search-results-wrapper').innerHTML;
            
            _THIS.renderSearchResults(htmlResult);
        })
        .catch((error) => {
            throw error;
        });*/

    }

    this.clearSearchResults = function() {
        $("#search-results").html("")
        $("#search-results").parent().find(".more-results").remove();
    }

    this.renderSearchResults = function(data) {


        if (data.results_count == 0) {
            _THIS.clearSearchResults();
            $("#search-results").html('<div class="col width-6 width-lg-12 text-center no-results-message"><p>' + theme.strings.search.noResults + '</p></div>');
        } else {

            var productList = '';
            var subItemList = '';

            //Number of items to show
            var productCountLimit = 8;
            var limitProductCountInitial = productCountLimit;
            var subItemCountLimit = 6;
            var productCount = 0;
            var subItemCount = 0;

            var searchWrap = $("#search-results")

            $.each(data.results, function(index, item) {

                if (item.type == 'product') {

                    if (productCountLimit > 0) {
                        //Print Item
                        var productPriceDiv = "";
                        var priceItemDiv = "";
                        var itemPrice = item.price;
                        var itemSalePrice = "";
                        let productHandle = "";
                        const pathParts = this.url.split("/").filter(part => part.trim() !== '');
                        productHandle = pathParts[pathParts.length - 1];
                        if (productHandle.includes('?')) {
                            productHandle = productHandle.split('?')[0];
                        }
                        if (item.compareprice_nocurrency > item.price_nocurrency) {
                            //if(item.compareprice > item.price) {
                            productPriceDiv = " price-on-sale";
                            priceItemDiv = " pre-sale";
                            itemPrice = item.compareprice;
                            itemSalePrice = '<span class="price-item sale">' + item.price + '</span>';
                        }

                        productList += '<li>';
                        productList += '  <div class="product-card" data-limoniapps-discountninja-product-handle="' + productHandle + '">';
                        productList += '    <div class="product-img">';
                        productList += '      <a href="' + item.url + '" title="' + item.title + '" class="product-link">';
                        productList += '        <img src="' + item.thumbnail + '" alt="' + item.title + '" />';
                        productList += '      </a>';
                        productList += '    </div>';
                        productList += '    <div class="product-detail">';
                        productList += '      <a href="' + item.url + '" title="' + item.title + '" class="product-link">';
                        productList += '        <div class="left">';
                        productList += '          <p class="product-title">' + item.title + '</p>';
                        productList += '        </div>';
                        productList += '        <div class="right">';
                        productList += '          <div class="product-price-wrap limoniapps-discountninja-productprice">';
                        productList += '            <div class="product-price' + productPriceDiv + '"><span class="price-item' + priceItemDiv + '">' + itemPrice + '</span>' + itemSalePrice + '</div>';
                        productList += '          </div>';
                        productList += '        </div>';
                        productList += '      </a>';
                        productList += '    </div>';
                        productList += '  </div>';
                        productList += '</li>';

                        /*
                        productList += '<li><div class="product-item">';
                        productList += '  <div class="product-item-container">';
                        productList += '    <a href="' + item.url + '" title="' + item.title + '">';
                        productList += '      <div class="product-item-image">';
                        productList += '        <img src="' + item.thumbnail + '" alt="' + item.title + '" />';
                        productList += '      </div>';
                        productList += '      <div class="product-item-infomation">';
                        productList += '        <div class="product-item-title" aria-label="' + item.title + '">' + item.title + '</div>';
                        productList += '        <div class="bottom-info">';
                        productList += '          <div class="product-item-price">';
                        productList += '            <div class="product-price' + productPriceDiv + '"><span class="price-item' + priceItemDiv + '">' + itemPrice + '</span>' + itemSalePrice + '</div>';
                        productList += '          </div>';
                        productList += '        </div>';
                        productList += '      </div>';
                        productList += '    </a>';
                        productList += '  </div>';
                        productList += '</div></li>';
                        */
                        productCountLimit--;
                    }

                    productCount++;
                    //resultsList.append(link);

                } else if (subItemCountLimit > 0) {
                    subItemList += '<li><a href="' + item.url + '" alt="' + item.title + '">' + item.title + '</a></li>';
                    subItemCountLimit--;
                    subItemCount++;
                }

            });

            //productList += '</ul></div></div>';
            //subItemList += '</ul></div>';

            var classProdList = "col width-6 width-lg-9 v-top";
            var classSubItemList = "col width-6 width-lg-3 v-top";

            var productListOpening = '<div id="search-results-products" class="' + classProdList + '"><h3>' + theme.strings.search.productsFor + ' "' + _THIS.searchTerm + '"</h3><div class="search-results"><ul>';
            var subItemListOpening = '<div id="search-results-articles" class="' + classSubItemList + '"><h3>' + theme.strings.search.titles.articles + '</h3><ul class="side-bar-search-results">';



            var productListClosing = '</ul></div></div>';
            var subItemListClosing = '</ul></div>';



            if (subItemCount == 0) {
                subItemList = "";
                classProdList = "col width-6 width-lg-12 v-top";
                classSubItemList = "col width-6 width-lg-2 v-top hide";
                searchWrap.addClass("no-articles");
            }

            productListOpening = '<div id="search-results-products" class="' + classProdList + '"><h3>' + theme.strings.search.productsFor + ' "' + _THIS.searchTerm + '"</h3><div class="search-results"><ul>';
            subItemListOpening = '<div id="search-results-articles" class="' + classSubItemList + '"><h3>' + theme.strings.search.titles.articles + '</h3><ul class="side-bar-search-results">';


            if (productCount < 1) {

                productList = '<div id="search-results-products" class="' + classProdList + '"><h3>' + theme.strings.search.productsFor + ' "' + _THIS.searchTerm + '"</h3><p class="no-products">' + theme.strings.search.noResults + '</p></div>';
                productListOpening = "";
                productListClosing = ""
            }




            $("#search-results").html(subItemListOpening + subItemList + subItemListClosing +
                productListOpening + productList + productListClosing);

            searchWrap.parent().find(".more-results").remove();
            if (data.results.length > limitProductCountInitial) {
                if (data.results_count > limitProductCountInitial) {
                    searchWrap.addClass("show-more-results").after('<div class="more-results"><a href="' + _THIS.searchURL + "?q=" + encodeURIComponent(_THIS.searchTerm) + '" class="btn sm mb-block btn-black">' + theme.strings.search.moreProducts + '<span class="desktop inline">&nbsp;(' + (data.results_count - limitProductCountInitial) + ')</span></a></div>');
                }
            }
        }




    }
}


export function setFancyConfirm(pcallback) {
    checkLibrary($.fancybox, theme.components.modalLibraryURL, function() {

        $.fancyConfirm = function(opts) {
            opts = $.extend(true, {
                title: 'Are you sure?',
                message: '',
                okButton: 'OK',
                noButton: 'CANCEL',
                callback: $.noop
            }, opts || {});

            $.fancybox.open({
                type: 'html',
                src: '<div class="fc-content align-center">' +
                    '<h2>' + opts.title.toUpperCase() + '</h2>' +
                    '<p>' + opts.message + '</p>' +
                    '<div class="action-buttons">' +
                    '<a class="btn btn-black outline sm" data-value="0" data-fancybox-close>' + opts.noButton.toUpperCase() + '</a>&nbsp;' +
                    '<button data-value="1" data-fancybox-close class="btn btn-black sm">' + opts.okButton.toUpperCase() + '</button>' +
                    '</div>' +
                    '</div>',
                opts: {
                    animationDuration: 350,
                    animationEffect: 'material',
                    modal: true,
                    baseTpl: '<div class="fancybox-container fc-container" role="dialog" tabindex="-1">' +
                        '<div class="fancybox-bg"></div>' +
                        '<div class="fancybox-inner">' +
                        '<div class="fancybox-stage"></div>' +
                        '</div>' +
                        '</div>',
                    afterClose: function(instance, current, e) {
                        var button = e ? e.target || e.currentTarget : null;
                        var value = button ? $(button).data('value') : 0;

                        opts.callback(value);
                    }
                }
            });
        }

        if (pcallback != null) return pcallback.call(this);
    })
}

/** Load Library on Demand  */
export function checkLibrary(library, libraryurl, callback) {

    if (typeof(library) == "undefined") { // we do not load fancy lib on page load but on quickview link (if lib not loaded yet)

        const script = document.createElement('script');
        script.src = libraryurl;

        // Append to the `head` element
        document.head.appendChild(script);
        script.addEventListener('load', function() {
            if (callback != null) return callback.call(this);
        });
    } else {
        if (callback != null) return callback.call(this);
    }

}



export function headerBagIcon() {
    var _THIS = this;
    this.updateBagIcon = function(cartItems) {
        if (cartItems == null) {
            $.getJSON(window.Shopify.routes.root + 'cart.js', function(cart) {
                refreshBagIcon(cart.item_count)
            });
        } else {
            refreshBagIcon(cartItems);
        }

    }

    var refreshBagIcon = function(itemCount) {
        if (itemCount > 0) {
            $("#header-icons .iconbag-item").addClass("has-items")
            $("#header-icons .iconbag-item .number").text(itemCount);
        } else {
            $("#header-icons .iconbag-item").removeClass("has-items")
            $("#header-icons .iconbag-item .number").text(0);
        }

    }
}


export function miniCart() {
    var _THIS = this;
    _THIS.cartData = null;
    _THIS.targetElement = null;
    _THIS.instHeaderIcon = null;
    this.init = function() {
        if ($("#mini-cart").hasClass("initialised")) {
            return;
        } else {
            $("#mini-cart").addClass("initialised")
            registerEvents();
        }

    }

    var registerEvents = function() {

        $(document).on("click", "#mini-cart-close", function(e) {
            e.preventDefault();
            _THIS.hideMiniCart();
        })

        $(document).on("click", "#mini-cart .mini-cart-overlay", function(e) {
            e.preventDefault();
            _THIS.hideMiniCart();
        })
         
         $(document).on("click","#mini-cart .quantity-step.plus",function(e){
            e.preventDefault(); 
            updateCartQuantity($(this),"plus")
        })

        $(document).on("click","#mini-cart .quantity-step.minus",function(e){
            e.preventDefault();
            updateCartQuantity($(this),"minus")
        })
        $(document).on("click", "#mini-cart .mini-cart-prod-remove", function(e) {
            e.preventDefault();

            var objArg = {}

            var getCartItemID = $(this).closest(".cart-line-item").attr("data-item-id")
            objArg.itemid = getCartItemID

            if (typeof(getCartItemID) !== "undefined") {
                sendG4Event("remove_from_cart", objArg)
            }
            removeMiniCartItem($(this).closest(".cart-line-item").attr("data-line-item-key"));
        })
    }

        var updateCartQuantity = function(elem,plusminus){
            var getQtyInput = elem.parent().find(".cart-qty-input")
            var getMin = parseInt(getQtyInput.attr("min"));
            var getMax = parseInt(getQtyInput.attr("max"));
            var getCurrentVal   = parseInt(getQtyInput.attr("value"));

            if(plusminus == "plus"){ 
                var newVal = getCurrentVal + 1;

                if(newVal > getMax){
                    newVal = getMax;
                }

            }else{
                
                var newVal = getCurrentVal - 1;

                if(newVal <=0 ){
                    newVal = getMin;
                }

            }

            getQtyInput.val(newVal);
            var lineitemid = elem.parents(".cart-line-item").attr("data-line-item-key");
            $('#mini-cart').addClass("minicart-updating");
            $('#mini-cart-loader').removeClass('hide');
            $("#mini-cart .cart-line-item[data-line-item-key='" + lineitemid  + "']").addClass("removing");
            let formData = {        
                'id': lineitemid,
                'quantity': newVal
              };
              fetch(window.Shopify.routes.root + 'cart/change.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
              })
              .then(response => {
               return response.json();
              })
              .then(data => {
                  _THIS.cartData = data
               _THIS.updateMiniCart(lineitemid)
               
              })
              .catch((error) => {
                console.error('Error:', error);
              });

        }

    var removeMiniCartItem = function(lineitemid) {

        $('#mini-cart').addClass("minicart-updating")

        $('#mini-cart-loader').removeClass('hide')

        $("#mini-cart .cart-line-item[data-line-item-key='" + lineitemid + "']").addClass("removing")

        /*$.post(window.Shopify.routes.root + 'cart/update.js', ,function( data ){
            console.log(data)
            console.log(typeof(data))
        } );*/


        /*$.ajax({
            method: "POST",
            url: window.Shopify.routes.root + 'cart/update.js',
            data: "updates[" + lineitemid + "]=0"
          })
            .done(function( msg ) {
              console.log(msg)
            });*/

        let formData = {

            'id': lineitemid,
            'quantity': 0

        };
        fetch(window.Shopify.routes.root + 'cart/change.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
            .then(response => {
                return response.json();
            })
            .then(data => {
                _THIS.cartData = data
                _THIS.updateMiniCart(lineitemid)

            })
            .catch((error) => {
                console.error('Error:', error);
            });




    }
    this.toggleDisplayMiniCart = function() {
        if (!$("#mini-cart").hasClass("active")) {
            _THIS.showMiniCart();
        } else {
            _THIS.hideMiniCart();
        }
    }

    this.getCartSectionHTML = function(callback) {

        $.getJSON(window.Shopify.routes.root + '?sections=mini-cart-content', function(cartcontent) {
            if (callback != null) return callback.call(this, cartcontent);

        })

    }


    this.showMiniCart = function() {
        $("#mini-cart").addClass("active");
        $("body").addClass("mini-cart-active");

        $("body").removeClass("search-active");
        $("body").removeClass("myaccount-login-active");
        $("body").removeClass("menu-active");
        $("body").removeClass("added-product-active")

        $("#search-dropdown").removeClass("active");
        $("#main-menu").removeClass("active");
        $("#added-product").removeClass("active");
        $("#myaccount-login").removeClass("active");

        _THIS.getCartSectionHTML(function(content) {

            $("#mini-cart .mini-cart-inner-wrapper").html(content["mini-cart-content"])

        })


        jQuery.getJSON('/cart.js', function(cart) {
            _THIS.cartData = cart
            sendG4Event("view_cart", null)
        });
    }

    this.hideMiniCart = function() {
        $("#mini-cart").removeClass("active");
        $("body").removeClass("mini-cart-active");
    }
    this.updateMiniCart = function(lineitemid) {
        //console.log( _THIS.cartData)

        $('#mini-cart').removeClass("minicart-updating")
        $('#mini-cart-loader').addClass('hide')
        // $("#mini-cart .cart-line-item[data-line-item-key='" + lineitemid  + "']").removeClass("removing").remove();
        if (_THIS.instHeaderIcon == null) {
            _THIS.instHeaderIcon = new headerBagIcon();
        }

        _THIS.instHeaderIcon.updateBagIcon(_THIS.cartData.item_count);
        _THIS.getCartSectionHTML(function(content) {

            $("#mini-cart .mini-cart-inner-wrapper").html(content["mini-cart-content"])

        })

        if (_THIS.cartData.item_count <= 0) {
            _THIS.hideMiniCart();

        } else {

        }


    }

    /*this.updateMiniCartDisplay = function(elem,minicartsection){
        _THIS.targetElement = elem;
        $.getJSON('/cart.js', function(cart){ 
            _THIS.cartData = cart;
          
            switch(minicartsection) {
                case 'header':
                    _THIS.updateMiniCartHeader();
                break;
                case 'body':
                    _THIS.updateMiniCartBody();
                break;
                case 'footer':
                    _THIS.updateMiniCartFooter();
                break;

                default:
                _THIS.updateMiniCart();
            }
        });  
    }

    this.updateMiniCart = function(){
        _THIS.updateMiniCartHeader();
        _THIS.updateMiniCartBody();
        _THIS.updateMiniCartFooter();
        
    }

    this.updateMiniCartHeader = function(){

    }


    this.updateMiniCartBody = function(){

    }


    this.updateMiniCartFooter = function(){
        console.log("updating added cart data")
        console.log(_THIS.cartData)
       
    }*/

    var sendG4Event = function(eventname, objArg) {

        var cartItems = _THIS.cartData.items;

        if (eventname == "view_cart") {



            var g4_items = [];

            for (var i = 0; i < cartItems.length; i++) {
                var objItems = {};
                objItems.item_id = cartItems[i].sku
                objItems.item_name = cartItems[i].product_title
                objItems.index = i
                objItems.item_variant = cartItems[i].variant_options[0]
                objItems.price = Shopify.formatMoney(cartItems[i].final_price, "{{amount}}").split(",").join("")
                objItems.quantity = cartItems[i].quantity

                if (cartItems[i].price !== cartItems[i].final_price) {
                    var discountAmount = cartItems[i].price - cartItems[i].final_price
                    objItems.discount = Shopify.formatMoney(discountAmount, "{{amount}}").split(",").join("")
                }



                g4_items.push(objItems);
            }

            if (typeof(gtag) !== 'undefined') {

                gtag("event", "view_cart", {
                    currency: _THIS.cartData.currency,
                    value: Shopify.formatMoney(_THIS.cartData.total_price, "{{amount}}").split(",").join(""),
                    items: g4_items
                });
            }
        } else if (eventname == "remove_from_cart") {



            var g4_items = [];

            for (var i = 0; i < cartItems.length; i++) {
                if (cartItems[i].id == objArg.itemid) {
                    var objItems = {};
                    objItems.item_id = cartItems[i].sku
                    objItems.item_name = cartItems[i].product_title
                    objItems.index = 0
                    objItems.item_variant = cartItems[i].variant_options[0]
                    objItems.price = Shopify.formatMoney(cartItems[i].final_price, "{{amount}}").split(",").join("")
                    objItems.quantity = cartItems[i].quantity

                    if (cartItems[i].price !== cartItems[i].final_price) {
                        var discountAmount = cartItems[i].price - cartItems[i].final_price
                        objItems.discount = Shopify.formatMoney(discountAmount, "{{amount}}").split(",").join("")
                    }



                    g4_items.push(objItems);
                    break;

                }
            }

            if (g4_items.length > 0) {
                if (typeof(gtag) !== 'undefined') {
                    gtag("event", "remove_from_cart", {
                        currency: _THIS.cartData.currency,
                        value: Shopify.formatMoney(_THIS.cartData.total_price, "{{amount}}").split(",").join(""),
                        items: g4_items
                    });
                }
            }
        }
    }
}

//
export function carousel() {
    var _THIS = this;

    //window.carousels = window.carousels || []

    this.elementContainer = null;
    this.init = function(elem) {
        _THIS.elementContainer = elem;


        //We make sure we target the right container

        initPromoFlags(_THIS.elementContainer + " .product-item-promo-flag");
        initPromoNames(_THIS.elementContainer + " .product-item-promo-name");

        //Check if there are slides to initialise
        //console.log(_THIS.elementContainer + "  " + $(_THIS.elementContainer + " .wrap-inner-slideshow .slide").length)
        if ($(_THIS.elementContainer + " .wrap-inner-slideshow .slide").length <= 0) {

            return;
        }

        //console.log(_THIS.elementContainer)
        registerEvents()
        checkCarouselNavigation();

        //window.carousels.push(_THIS.elementContainer)

        let doDebounce = debounce(() => checkCarouselNavigation(), 300)
        window.addEventListener("resize", () => doDebounce())

        $(window).trigger("resize");

    }


    var debounce = (callback, delay) => {
        let myTimeout;
        return () => {
            clearTimeout(myTimeout);
            myTimeout = setTimeout(() => {
                callback()
            }, delay);
        };
    };

    var registerEvents = function() {
        $(document).on("click", _THIS.elementContainer + " .carousel-header .next", function(e) {
            e.preventDefault();
            _THIS.moveCarousel("next")
        })

        $(document).on("click", _THIS.elementContainer + " .carousel-header .prev", function(e) {
            e.preventDefault();
            _THIS.moveCarousel("prev")
        })
    }

    var checkCarouselNavigation = function() {
        //console.log("checking carousel navigation" + Math.random())
        var container = $(_THIS.elementContainer + " .wrap-slideshow");
        var slider = $(_THIS.elementContainer + " .wrap-inner-slideshow");
        var slideWidth = slider.find(".slide").eq(0).width();
        var containerwidth = container.width();
        var scrollWidth = (slideWidth * slider.find(".slide").length);
        scrollWidth = Math.floor(scrollWidth); //to prevent decimal

        var targetContainer = $(_THIS.elementContainer);

        if (targetContainer.hasClass("shopify-section")) {
            targetContainer = $(_THIS.elementContainer + " .carousel")
        } else {
            if ($(_THIS.elementContainer + " .carousel").length > 0) {
                targetContainer = $(_THIS.elementContainer + " .carousel").eq(0)
            }
        }

        // console.log(_THIS.elementContainer  + "   " + scrollWidth + " "  + containerwidth)

        if (scrollWidth <= containerwidth) {

            targetContainer.addClass("disable-navigation");
        } else {

            targetContainer.removeClass("disable-navigation");
        }
        //console.log(_THIS.elementContainer + "   scrollWidth: " + scrollWidth +  "    " + "containerwidth: " + containerwidth)

    }

    this.moveCarousel = function(action) {

        var container = $(_THIS.elementContainer + " .wrap-slideshow");
        var slider = $(_THIS.elementContainer + " .wrap-inner-slideshow");
        var slideWidth = slider.find(".slide").eq(0).width()

        //Check current scroll position
        var containerwidth = container.width();
        var scrollWidth = (slideWidth * slider.find(".slide").length);
        scrollWidth = Math.floor(scrollWidth); //to prevent decimal
        var scrollcontent = containerwidth + container.scrollLeft();

        if (action == "next") {
            if (scrollcontent >= scrollWidth) {
                container.scrollLeft(0);
                return;
            }

        } else { //prev
            if (container.scrollLeft() <= 0) {
                container.scrollLeft(scrollWidth)
                return;
            }

        }
        //console.log((action=="next"?(container.scrollLeft() + slideWidth): (container.scrollLeft() - slideWidth)))

        $(container).animate({
            scrollLeft: (action == "next" ? (container.scrollLeft() + slideWidth) : (container.scrollLeft() - slideWidth))
        }, 300, function() {
            //complete scrolling
        });
    }

}

export function getJsonProductInformation(phandle, callback) {
    $.ajax({
        type: 'GET',
        url: window.Shopify.routes.root + 'products/' + phandle + '?view=customproduct.json',
        success: function(response) {
            var json_response = JSON.parse(response);
            if (callback != null) return callback.call(this, json_response);
        },
        error: function(status) {
            console.warn('ERROR', status);
        }
    })

}



//Handling Multiple Ajax Request to get list of Product information
export function getProductsInformation(arrayHandles, usevalueprop, callback) {

    var requests = [];
    var responses = [];

    for (var i = 0; i < arrayHandles.length; i++) {

        requests.push($.ajax({
            type: 'GET',
            url: window.Shopify.routes.root + 'products/' + (usevalueprop == true ? arrayHandles[i]["value"] : arrayHandles[i]) + '?view=card',
            h: (usevalueprop == true ? arrayHandles[i]["value"] : arrayHandles[i]),
            //theme.devSettings.requestLocale + '/products/' + arrayHandles[i]["value"] + '?view=customproduct.json',
            success: function(response) {

                var json_response = response; //JSON.parse(response);

                responses.push({
                    "handle": this.h,
                    "response": json_response
                });
            }
        }).catch(function(jqXhr) {
            return {
                error: true,
                status: jqXhr.status,
                statusText: jqXhr.statusText
            };
        }))
    }


    $.when.apply($, requests).done(function() {

        if (callback != null) return callback.call(this, responses);
    })


}


export function onlyUniqueHandle(a) {
    var r = new Array();
    o: for (var i = 0, n = a.length; i < n; i++) {
        for (var x = 0, y = r.length; x < y; x++) {
            if (r[x]["value"] == a[i]["value"]) continue o;
        }
        r[r.length] = a[i];
    }
    return r;
}

export function recentlyViewed() {
    var _THIS = this;

    this.elementContainer = null;
    this.init = function(elem) {
        _THIS.elementContainer = elem;
        generateRecentlyProducts()
    }

    var generateRecentlyProducts = function() {

        var recentlyProducts = _THIS.getRecentlyViewed();

        var visibleProducts = 4;
        //reformat array to array objecs

        if (recentlyProducts.length > 0) {
            $(_THIS.elementContainer).find(".carousel").removeClass("hide")

            /*var elVisileProducts = $(_THIS.elementContainer).find(".carousel").attr("data-visible-products")
            if(typeof(elVisileProducts)!=="undefined"){
                visibleProducts = elVisileProducts;
            }*/

            /*if(recentlyProducts.length < visibleProducts ){
                $(_THIS.elementContainer).find(".carousel").addClass("disable-navigation")
            }*/
            getProductsInformation(recentlyProducts, false, function(data) {

                //$( _THIS.elementContainer).html(data);
                var htmlData = "";
                for (var i = 0; i < data.length; i++) {
                    htmlData += data[i].response;
                }
                $(_THIS.elementContainer).find(".wrap-inner-slideshow").html(htmlData);


                var insRecentlyCarousel = new carousel();
                insRecentlyCarousel.init(_THIS.elementContainer);

                $(_THIS.elementContainer + " .product-item-swatches .cycle-slideshow").cycle();



                (async () => {
                    const {
                        default: models
                    } = await import(theme.components.modelsURL);

                    models.updateModelsDisplay(_THIS.elementContainer + " .product-media");
                })();
            });
        } else {
            $(_THIS.elementContainer).find(".carousel").addClass("hide")
            //$(_THIS.elementContainer).find(".carousel").removeClass("disable-navigation")
        }

    }

    this.saveRecentlyViewed = function(handle) {


        var getRecently = this.getRecentlyViewed()

        var position = $.inArray(handle, getRecently);


        if (position === -1) {
            // Add product at the start of the list.
            getRecently.unshift(handle);
            // Only keep what we need.
            getRecently = getRecently.splice(0, 20);
        } else {
            // Remove the product and place it at start of list.
            getRecently.splice(position, 1);
            getRecently.unshift(handle);
        }

        Cookies.set("shopify_recently_viewed", getRecently.join(" "), 365);
    }

    this.getRecentlyViewed = function() {

        var retCently = []
        var getRetC = Cookies.get("shopify_recently_viewed");

        if (typeof(getRetC) !== "undefined" && getRetC !== "") {
            retCently = getRetC.split(" ");
        }
        return retCently;

    }

}
export function customTabs() {
    var _THIS = this;

    this.init = function() {
        $(document).off("click", ".tab_content .tab-scroller a")
        _THIS.registerEvents();
    }

    this.registerEvents = function() {
        $(document).on("click", ".tab_content .tab-scroller a", function(e) {
            e.preventDefault();
            $(this).parent().siblings().removeClass("sel")
            $(this).parent().addClass("sel")
            var selCharType = $(this).attr("href")

            $(this).closest(".tab_content").find(".tab-content").removeClass("sel")
            $(this).closest(".tab_content").find(selCharType).addClass("sel")
        })
    }
}


export function customSizeChartTabs() {
    var _THIS = this;

    this.init = function() {
        $(document).off("click", ".tab-scroller a")
        _THIS.registerEvents();
    }

    this.registerEvents = function() {
        $(document).on("click", ".tab-scroller a", function(e) {
            e.preventDefault();
            $(this).parent().siblings().removeClass("sel")
            $(this).parent().addClass("sel")
            var selCharType = $(this).attr("href")

            $(this).closest(".size-chart-brand-wrap").find(".size-chart-wrap").removeClass("sel")
            $(this).closest(".size-chart-brand-wrap").find(selCharType).addClass("sel")
        })
    }
}

export function emailValidate() {
    var _THIS = this;
    this.emailRetryCounter = 0
    this.init = function(emailfield, inpsubmit, pcallback) {
        var label = emailfield.attr("name").split("[").join("-").split("]").join("") || "";
        emailfield.bind("blur", function() {

            if (emailfield.val().length <= 0) {
                emailfield.removeClass("valid").addClass("invalid");
                if (pcallback != null) return pcallback.call(this, false);

            } else {
                var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
                if (reg.test(emailfield.val()) == false) {
                    $(emailfield).removeClass("valid").removeClass("processing").addClass("invalid");
                    $(emailfield).focus();
                    if (pcallback != null) return pcallback.call(this, false);
                } else {
                    emailfield.removeClass("invalid").removeClass("valid").addClass("processing");
                    inpsubmit.attr("disabled", "disabled")
                    _THIS.emailValidator(emailfield.val(), function(json) {
                        emailfield.removeClass("processing");
                        inpsubmit.prop("disabled", false)

                        _THIS.gaTrackEmailValidationEvent('Email Validation', 'Total Requests', label)


                        if (typeof(json.status) != "undefined") {

                            // valid addresses have a {200, 207, 215} result
                            // result codes 114 and 118 need a retry
                            var statuscode = json.status;
                            if (statuscode == '114' || statuscode == '118' ||
                                statuscode == '119' || statuscode == '121' ||
                                statuscode == '200' || statuscode == '207' ||
                                statuscode == '215' || statuscode == '308' ||
                                statuscode == '317'
                            ) {

                                _THIS.gaTrackEmailValidationEvent('Email Validation', "(" + json.status + ") " + json.info, label)
                                emailfield.removeClass("invalid").addClass("valid");
                                _THIS.emailRetryCounter = 0;
                                if (pcallback != null) return pcallback.call(this, true);
                            } else if (statuscode == '313') {
                                if (_THIS.emailRetryCounter < 5) {
                                    _THIS.emailRetryCounter++;
                                    emailfield.trigger("blur");
                                } else {
                                    _THIS.gaTrackEmailValidationEvent('Email Validation', "(" + json.status + ") " + json.info, label)
                                    emailfield.removeClass("valid").addClass("invalid");
                                    if (pcallback != null) return pcallback.call(this, false);
                                }
                            } else {
                                _THIS.gaTrackEmailValidationEvent('Email Validation', "(" + json.status + ") " + json.info, label)
                                _THIS.emailRetryCounter = 0;
                                emailfield.removeClass("valid").addClass("invalid");
                                if (pcallback != null) return pcallback.call(this, false);
                            }
                        } else { //problem with the API 
                            _THIS.gaTrackEmailValidationEvent('Email Validation', "(Undefined) " + json.Message, label)
                            emailfield.removeClass("valid").addClass("invalid");
                            if (pcallback != null) return pcallback.call(this, true);
                        }
                    })
                } //
            }
        })
    }

    this.emailValidator = function(pemailAddress, pcallback) {
        //First we check if email Address is part of whitelisted addresses

        var whiteListedEmailAddresses = [
            "@rejoiner.com",
            "@triumph.com",
            "@nowsolutions.com.au",
            "@stockinstore.com"
        ]

        var foundWhiteListed = false;

        for (var i = 0; i < whiteListedEmailAddresses.length; i++) {
            var re = new RegExp(whiteListedEmailAddresses[i])

            if (pemailAddress.match(re)) {
                foundWhiteListed = true;
                break;
            }
        }



        if (!foundWhiteListed) {
            $.ajax({
                url: '//api.email-validator.net/api/verify',
                type: 'POST',
                cache: false,
                crossDomain: true,
                data: {
                    EmailAddress: pemailAddress,
                    APIKey: theme.devSettings.emailApiKey
                },
                dataType: 'json',
                success: function(json) {
                    if (pcallback != null) return pcallback.call(this, json);
                },
                error: function(xhr, status, error) {

                    var err = JSON.parse(xhr.responseText);
                    if (pcallback != null) return pcallback.call(this, err);
                }
            });

        } else {

            var wjson = {};
            wjson.status = "200";
            wjson.info = "Whitelisted Email Address - No Call to Email Validation API"
            if (pcallback != null) return pcallback.call(this, wjson);

        }

    }


    this.gaTrackEmailValidationEvent = function(category, action, label) {
        if (typeof(gtag) != "undefined") {
            //ga('send', 'event', category, action.toLowerCase(), label);
            gtag('event', category, {
                'action': action.toLowerCase(),
                'label': label
            })
        }
    }

}

export function phoneValidate() {
    var _THIS = this;
    this.init = function(phonefeldstr, isphonefeldMandatory, inpsubmit, pcallback) {
        $(document).on("blur", phonefeldstr, function(e) {
            var phonefeld = $(this);
            var phonePattern = /^0[0-8]\d{8}$/g;
            if (phonefeld.val() == "") {
                if (isphonefeldMandatory) {
                    phonefeld.removeClass("valid").addClass("invalid");
                    if (pcallback != null) return pcallback.call(this, false);
                } else {
                    phonefeld.removeClass("valid").removeClass("invalid");
                    if (pcallback != null) return pcallback.call(this, true);
                }
            } else {

                //Exception to field validation in specific areas
                if (phonefeldstr == "#checkout_billing_address_phone") {
                    if (typeof($("#checkout_billing_address_country option:selected").attr("data-code")) !== "undefined") {
                        if ($("#checkout_billing_address_country option:selected").attr("data-code") !== theme.devSettings.countrycode) {
                            phonefeld.removeClass("valid").removeClass("invalid");
                            if (pcallback != null) return pcallback.call(this, true);

                        }
                    }
                }

                if ($("body").hasClass("template-customers")) {
                    //console.log("step 1: " +  phonefeldstr)
                    if (phonefeldstr.indexOf("address[phone]") !== -1) {
                        //console.log("step 2")
                        var selCountry = phonefeld.closest("form").find("select[name='address[country]']")
                        //console.log(selCountry)
                        if (selCountry.find("option:selected").attr("value") !== theme.devSettings.countryname) {
                            phonefeld.removeClass("valid").removeClass("invalid");
                            if (pcallback != null) return pcallback.call(this, true);
                        }

                    }
                }




                phonefeld.removeClass("invalid").removeClass("valid").addClass("processing");
                inpsubmit.attr("disabled", "disabled")

                _THIS.phoneValidator(phonefeld, phonefeld.val(), function(json) {
                    phonefeld.removeClass("processing");
                    //inpsubmit.prop("disabled",false)
                    var label = "Triumph-" + theme.devSettings.countrycode
                    _THIS.gaTrackPhoneValidationEvent('Phone Validation', 'Total Requests', label);
                    if (typeof(json.status) != "undefined") {
                        var statuscode = json.status;
                        switch (statuscode) {
                            case "VALID_CONFIRMED":
                            case "VALID_UNCONFIRMED":
                            case "DELAYED":
                                _THIS.gaTrackPhoneValidationEvent('Phone Validation', "(" + json.status + ") ", label);
                                phonefeld.removeClass("invalid").addClass("valid").parent().find('span.fa').remove();
                                if (pcallback != null) return pcallback.call(this, true);

                                break;
                            case "INVALID":
                            default:
                                _THIS.gaTrackPhoneValidationEvent('Phone Validation', "(" + json.status + ") ", label);
                                phonefeld.removeClass("valid").addClass("invalid") //.parent().find('span.fa').remove();
                                if (pcallback != null) return pcallback.call(this, false);
                        }
                    } else {
                        _THIS.gaTrackPhoneValidationEvent('Phone Validation', "(Undefined) ", label);
                        phonefeld.removeClass("valid").addClass("invalid") //.parent().find('span.fa').remove();
                        if (pcallback != null) return pcallback.call(this, false);
                    }
                })
            }
        })
    }

    this.phoneValidator = function(phonefeld, pphonenumber, pcallback) {

        var apiData = {
            PhoneNumber: pphonenumber,
            Locale: theme.devSettings.language,
            APIKey: theme.devSettings.phoneApiKey
        }


        if (pphonenumber.indexOf("+") == -1) {
            apiData.CountryCode = theme.devSettings.countrycode.toLowerCase();
        }


        //ajaxPhoneValidInst = 
        $.ajax({
            url: '//api.phone-validator.net/api/v2/verify',
            type: 'POST',
            cache: false,
            crossDomain: true,
            data: apiData,
            dataType: 'json',
            success: function(json) {

                if (pcallback != null) return pcallback.call(this, json);
            }
        });
    }

    this.gaTrackPhoneValidationEvent = function(category, action, label) {
        if (typeof(gtag) != "undefined") {
            //ga('send', 'event', category, action.toLowerCase(), label);
            gtag('event', category, {
                'action': action.toLowerCase(),
                'label': label
            })
        }
    }

}



/** Sitewide Quiz Bra Calculator/Measurement */

export function quizCalculator(){
    var _THIS = this;
    this.isLoading = false;
    this.quizObject = {
        style:"", 
        collection:"", //"/collections/bras/style__en__"
        link:"",
        ovbust:0,
        unbust:0,
        cup:"",
        band:"",
        result:""
    }


    if(Shopify.country == "AU" || Shopify.country == "NZ"){


            _THIS.sizeChart  = {
                ubust:[
                    {from:53,to:59, size:6, osize:30},
                    {from:60,to:66, size:8, osize:32},
                    {from:67,to:73, size:10, osize:34},
                    {from:74,to:80, size:12, osize:36},
                    {from:81,to:87, size:14, osize:38},
                    {from:88,to:94, size:16, osize:40},
                    {from:95,to:101, size:18, osize:42},
                    {from:102,to:108, size:20, osize:44},
                    {from:109,to:115,size:22, osize:44},
                    {from:116,to:122,size:24, osize:44}
                ],
                cup:[
                    {from:10,to:12,size:"AA"},
                    {from:13,to:14,size:"A"},
                    {from:15,to:16,size:"B"},
                    {from:17,to:18,size:"C"},
                    {from:19,to:20,size:"D"},
                    {from:21,to:22,size:"DD"},
                    {from:23,to:24,size:"E"},
                    {from:25,to:26,size:"F"},
                    {from:27,to:28,size:"G"},
                    {from:29,to:30,size:"H"}
                ]
            }

    }else if(
            Shopify.country == "HK" || Shopify.country == "IN" || Shopify.country == "TH" || 
            Shopify.country == "MY"  || Shopify.country == "SG"  || Shopify.country == "VN" 
            ){
            _THIS.sizeChart = {
                ubust:[
                    {from:68, to:72, size:70, osize:32},
                    {from:73, to:77, size:75, osize:34},
                    {from:78, to:82, size:80, osize:36},
                    {from:83, to:87, size:85, osize:38},
                    {from:88, to:92, size:90, osize:40},
                    {from:93, to:97, size:95, osize:42},
                    {from:98, to:102, size:100, osize:44}
                ],
                cup:[
                    {from:10,to:12,size:"A"},
                    {from:13,to:14,size:"B"},
                    {from:15,to:17,size:"C"},
                    {from:18,to:19,size:"D"},
                    {from:20,to:22,size:"E"},
                    {from:23,to:24,size:"F"},
                    {from:25,to:26,size:"G"},
                    {from:27,to:28,size:"H"},
                    {from:29,to:30,size:"I"}
                ]            
        }
    }

    
  this.init = function(){
    _THIS.registerEvents();
  }

  this.initialiseQuiz = function(){        

    this.initSliders("#ovbust-slider-container");
    this.initSliders("#unbust-slider-container");

    

  }

  this.initSliders = function(containerstring){
    var container = document.querySelector(containerstring);
    var slider = container.querySelector('.range-slider');
    var handle = container.querySelector('.slider-handle');
    var markerpos = 5;
    var emptyticks = 2;

    const createRuler = ()=>{
        const start = parseInt(slider.min);
        const end = parseInt(slider.max)
    
        const containerWidth = container.parentNode.offsetWidth; //window.innerWidth <= 768?window.innerWidth:396//

   
        const totalTicks =(containerWidth / (((end+emptyticks)-(start-emptyticks))));
        const tickerWidth = ((end+4)-start)*totalTicks

        const ruler = container.parentNode.querySelector(".ruler")
        ruler.innerHTML = ""; // Clear existing ticks
        const tickLine = document.createElement("div");
        tickLine.classList.add("ruler-line");
        ruler.appendChild(tickLine)

        
        ruler.style.width = `${tickerWidth}px`;
        tickLine.style.width= `${tickerWidth}px`;
        container.querySelector(".range-slider").style.width = `${tickerWidth}px`;

        for (let i = (start-emptyticks); i <= (end+emptyticks); i++) {
            const tick = document.createElement("div");
            tick.classList.add("tick");

            // Determine tick size
            if (i % markerpos === 0) {
                tick.classList.add("large");
            //} else if (i % 5 === 0) {
            //    tick.classList.add("medium");
            } else {
                tick.classList.add("small");
            }

            tick.style.left = `${(i-(start-emptyticks)) * totalTicks}px`;

            // Add numbering for large ticks
            if (i % markerpos === 0) {
                const label = document.createElement("span");
                label.innerText = i;
                tick.appendChild(label);
            }

            ruler.appendChild(tick);
        }


    }
    createRuler();
    

    // Update handle position and value
    const updateHandle = () => {
        const value = parseInt(slider.value);
        const min = parseInt(slider.min);
        const max = parseInt(slider.max);

        // Calculate the percentage position of the slider thumb
        const percentage = ((value - (min-2)) / ((max+2) - (min-2))) * 100;

        // Update the handle position and display value
        //handle.style.left = `calc(${percentage}% + (${8 - percentage * 0.15}px))`; // Adjust for padding
        handle.style.left = `calc(${percentage}%)`; // Adjust for padding
        handle.setAttribute('data-value', value);
    };

    // Initialize handle position
    updateHandle();

    // Add event listener for slider movement
    slider.addEventListener('input', updateHandle);
    slider.addEventListener('change', function(event){
        const sliderObj= event.target.getAttribute("data-class");

        if(sliderObj == "ovbust"){
            _THIS.sendAnalytics(`Quiz Select Overbust: ${event.target.value}`)
        }

        if(sliderObj == "unbust"){
            _THIS.sendAnalytics(`Quiz Select Underbust: ${event.target.value}`)
        }
    });


    window.addEventListener("resize", createRuler);
    window.addEventListener("load", createRuler);
   

  }
    
  this.loadQuizContent = function(){
    if (document.getElementById('quizCalculator')) {
            if ($('#quiz-popup').length === 0) {
               const popupHtml = `
                 <div id="quiz-popup">
                   <div class="wrap-content">
                     <div class="inner-wrap">
                       <div class="loader-content">
                         <img src="${theme.loaderImage}" />
                       </div>
                       <div class="quiz-wrap"></div>
                     </div>
                   </div>
                 </div>
               `;
           
               // Insert before #web-pixels-manager-sandbox-container
               $('#quizCalculator').html(popupHtml);
             }
           
             // Show the popup (you can customize how it's displayed)
             $('#quiz-popup').show();
           
             // Load quiz content
             $.getJSON(window.Shopify.routes.root + '?sections=quiz-calculator-content', function (quickcontent) {
               $('#quiz-popup .quiz-wrap').html(quickcontent['quiz-calculator-content']);
               $('#quiz-popup .loader-content').addClass('hide');
               _THIS.isLoading = false;
           
               setTimeout(function () {
                 _THIS.initialiseQuiz();
               }, 300);
             });

    }else{
    checkLibrary($.fancybox, theme.components.modalLibraryURL, function(){
        $.fancybox.open('<div id="quiz-popup"><div class="wrap-content"><div class="inner-wrap"><div class="loader-content"><img src="' + theme.loaderImage + '" /></div><div class="quiz-wrap"></div></div></div></div></div>',{
            beforeShow : function( instance, current ) {
                $.getJSON(window.Shopify.routes.root + '?sections=quiz-calculator-content', function(quickcontent){ 
                    $("#quiz-popup .inner-wrap .quiz-wrap").html(quickcontent['quiz-calculator-content']);
                    $("#quiz-popup .loader-content").addClass("hide");
                    _THIS.isLoading = false;
                    setTimeout(function(){
                        _THIS.initialiseQuiz();
                    },300)
                    
                })                
            }	
        });
    })
    }   
  }

  this.sendAnalytics = function(event){
    console.log(`DATA LAYER: ${event}`)
  }



  this.calculateBraSize = function(){
        var ubustArr = _THIS.sizeChart.ubust; 
        var ubustVal = parseInt(this.quizObject.unbust);

        for(var i=0;i<ubustArr.length;i++){
            if(ubustVal>=ubustArr[i].from && ubustVal<=ubustArr[i].to ){
                console.log(ubustVal + "   band:" + ubustArr[i].size)
                _THIS.quizObject.band = ubustArr[i].size;
                break;
            }
        }

        
        var cupSize = parseInt(this.quizObject.ovbust)  -   parseInt(this.quizObject.unbust);
        _THIS.quizObject.cup = '';
        for(var i=0;i<_THIS.sizeChart.cup.length;i++){
            if(cupSize >= _THIS.sizeChart.cup[i].from && cupSize <= _THIS.sizeChart.cup[i].to ){
                console.log(cupSize + "   cup:" + _THIS.sizeChart.cup[i].size)
                _THIS.quizObject.cup = _THIS.sizeChart.cup[i].size
                break;
            }
        }
        _THIS.quizObject.result  = _THIS.quizObject.band + _THIS.quizObject.cup;
        let colFilter = _THIS.quizObject.collection;
        _THIS.quizObject.link = window.Shopify.routes.root + "collections/bras/" +  "style__" + window.Shopify.locale + "__" + colFilter + "+" + "size__" + _THIS.quizObject.result.toLowerCase();

  }

  this.slugify = function(input) {
    return input
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')  // Replace non-alphanumeric groups with hyphen
      .replace(/^-+|-+$/g, '');     // Remove leading/trailing hyphens
  }

  this.displayResult = function(){
    
    this.calculateBraSize()
    console.log(this.quizObject)
    if(_THIS.quizObject.cup){
    $("#quiz-popup .answer").removeClass("hide")
    $(".answer .selected-style").html(_THIS.quizObject.style);
    $(".answer .btn-view-collection").attr("href",_THIS.quizObject.link)
    $(".answer .quiz-result").html( _THIS.quizObject.result);
    $(".answer.login").addClass("hide")
    }else{
        $("#quiz-popup .answer").addClass("hide")
        $("#quiz-popup .errorNotFound").removeClass("hide")
    }
    this.setCookie("quizBraData", JSON.stringify(_THIS.quizObject), 1); // Cookie will expire in 7 days
    if(theme.userID!=="" && theme.userEmailAddress!==""){
        //save to insider

        _THIS.sendToInsider();
    }else{
        if(typeof(Insider)!=='undefined'){
            $(".answer .login").removeClass("hide")
        }
        
    }

  }

  this.sendToInsider = function(){

    window.insider_object = window.insider_object || {};
    window.insider_object.user = {
          "gdpr_optin":true,
          "email":theme.userEmailAddress,
          "email_optin":true,
          "language":(Shopify.locale + "-" + Shopify.country).toLowerCase(),
          "custom": {
            "bras_size":_THIS.quizObject.result
          }
    }

  }

  this.setCookie = function(name, value, days) {
        let expires = "";
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
   }

  this.registerEvents = function(){
    if (document.getElementById('quizCalculator')) {
        _THIS.isLoading = true;
        _THIS.loadQuizContent();
        _THIS.sendAnalytics("Quiz Load")
    }else{
        $(".quiz-calculator").click(function(e){
             e.preventDefault();
             if(!_THIS.isLoading)  {
                _THIS.isLoading = true;
                _THIS.loadQuizContent();
                _THIS.sendAnalytics("Quiz Load")
    
             } 
        });
    }
 
        $(document).on("click","#quiz-popup .btn-start" ,function(e){
             e.preventDefault();
             $("#quiz-popup .steps.intro").addClass("hide")
             $("#quiz-popup .steps.step1 ").removeClass("hide")
             _THIS.sendAnalytics("Quiz Step 1")
             _THIS.fillProgressBar(25)
        }) 
 
         $(document).on("click","#quiz-popup .btn-apply-style" ,function(e){
            e.preventDefault();
            if($(this).hasClass("disabled")){
                return;
            }  

            if($("#quiz-popup .style-grid-item.selected").length<=0){
                return;

            }
            $("#quiz-popup .steps.step1").addClass("hide")
            $("#quiz-popup .steps.step2").removeClass("hide")
            _THIS.fillProgressBar(50)
            _THIS.sendAnalytics("Quiz Step 2")            
            window.dispatchEvent(new Event('resize'));
         })
 
 
         $(document).on("click","#quiz-popup .step2 .btn-prev" ,function(e){
             e.preventDefault();
             $("#quiz-popup .steps.step2").addClass("hide")
             $("#quiz-popup .steps.step1").removeClass("hide")
             _THIS.sendAnalytics("Quiz Step 1")
             _THIS.fillProgressBar(25)
            
         })
         $(document).on("click","#quiz-popup .step2 .btn-next" ,function(e){
             e.preventDefault();
             $("#quiz-popup .steps.step2").addClass("hide")
             $("#quiz-popup .steps.step3").removeClass("hide")
             _THIS.fillProgressBar(75)
             _THIS.sendAnalytics("Quiz Step 3")
             _THIS.quizObject.ovbust = $("#ovbust-range-slider").val()
             window.dispatchEvent(new Event('resize'));
         })
 
 
         $(document).on("click","#quiz-popup .step3 .btn-prev" ,function(e){
             e.preventDefault();
             $("#quiz-popup .steps.step3 ").addClass("hide")
             $("#quiz-popup .steps.step2").removeClass("hide")
             _THIS.sendAnalytics("Quiz Step 2")
             _THIS.fillProgressBar(50)
             window.dispatchEvent(new Event('resize'));
         })
 
         $(document).on("click","#quiz-popup .step3 .btn-next" ,function(e){
             e.preventDefault();
             $("#quiz-popup .steps.step3 ").addClass("hide")
             _THIS.fillProgressBar(100)
             _THIS.sendAnalytics("Display Result")
             _THIS.quizObject.unbust = $("#unbust-range-slider").val()
             _THIS.displayResult();
         })
         
         $(document).on("click","#quiz-popup .style-grid-item" ,function(e){
             e.preventDefault();
                
             $("#quiz-popup .style-grid-item").removeClass("selected")
             $(this).addClass("selected")
             _THIS.sendAnalytics("Select Style: "  + $("#quiz-popup .style-grid-item.selected .style-name").text() )
             $("#quiz-popup .btn-apply-style").removeClass("disabled");

             _THIS.quizObject.style = $("#quiz-popup .style-grid-item.selected .style-name").text(); 
             _THIS.quizObject.collection = $("#quiz-popup .style-grid-item.selected").attr("collectionhandle"); 
            
         }) 

         $(document).on("click","#quiz-popup .quiz-calculator-btn" ,function(e){
            e.preventDefault();
            if (document.getElementById('quizCalculator')) {
                _THIS.isLoading = true;
                _THIS.loadQuizContent();
                _THIS.sendAnalytics("Quiz Load")
            }else{
                document.getElementsByClassName("fancybox-close-small")[0].click(); 
                document.getElementsByClassName("quiz-calculator")[0].click()
            }
         });
  }

  this.fillProgressBar = function(percentage) {
     const progressBar = document.querySelector('#quiz-popup .quiz-progress-bar');
     if (progressBar) {
         // Limit the percentage between 0 and 100
         percentage = Math.min(Math.max(percentage, 0), 100);
         progressBar.style.width = percentage + '%';
     } else {
         console.error('Progress bar element not found.');
     }
  }

 }


export function initPromoFlags(container) {
    var searchObject = null;
    if (typeof(container) == 'string') {
        searchObject = $(container);
    } else {
        searchObject = container;
    }
    searchObject.each(function() {

        var promostart = $(this).attr("data-promo-start")
        var promoend = $(this).attr("data-promo-end")
        var _THIS = $(this)
        try {
            var options = {
                timeZone: theme.devSettings.regional,
                month: 'numeric',
                day: 'numeric',
                year: 'numeric',
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit"
            };
            var currentBrisbaneTime = new Date().toLocaleDateString(theme.devSettings.language, options, options);
            var start = new Date(promostart)
            var end = new Date(promoend)


            var arrCountryTime = currentBrisbaneTime.split(",")


            if (arrCountryTime.length >= 2) {
                var datePart = arrCountryTime[0]
                var arrBrisDate = datePart.split("/")
                var daypart = arrBrisDate[0]
                var monthpart = arrBrisDate[1]
                var yearpart = arrBrisDate[2]

                var newStringBrisTime = monthpart + '/' + daypart + '/' + yearpart;
                var newFullStringBrisTime = newStringBrisTime + ',' + arrCountryTime[1];
                var currentBrisDate = new Date(newFullStringBrisTime);

                if (!(currentBrisDate instanceof Date && !isNaN(currentBrisDate))) {
                    var currentBrisDate = new Date(currentBrisbaneTime);
                }

                // console.log(currentBrisDate)
                // console.log(start + "  " + end)
                if (_THIS.text().length > 1) {
                    if (currentBrisDate >= start && currentBrisDate <= end) {
                        _THIS.removeClass('hide')
                        _THIS.parent().find(".product-item-flag").addClass("hide")
                    } else {
                        _THIS.parent().find(".product-item-flag").removeClass("hide")
                    }
                }

            } else {
                if (_THIS.text().length > 1) {
                    _THIS.parent().find(".product-item-flag").removeClass("hide")
                }
                return
            }


        } catch (err) {
            //console.log(err)
            if (_THIS.text().length > 1) {
                _THIS.parent().find(".product-item-flag").removeClass("hide")
            }
            return;
        }


    })
}



export function initPromoNames(container) {
    var searchObject = null;
    if (typeof(container) == 'string') {
        searchObject = $(container);
    } else {
        searchObject = container;
    }
    searchObject.each(function() {

        var promostart = $(this).attr("data-promo-start")
        var promoend = $(this).attr("data-promo-end")
        var _THIS = $(this)
        try {
            var options = {
                timeZone: theme.devSettings.regional,
                month: 'numeric',
                day: 'numeric',
                year: 'numeric',
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit"
            };
            var currentBrisbaneTime = new Date().toLocaleDateString(theme.devSettings.language, options);
            var start = new Date(promostart)
            var end = new Date(promoend)

            var arrCountryTime = currentBrisbaneTime.split(",")
            if (arrCountryTime.length >= 2) {
                var datePart = arrCountryTime[0]
                var arrBrisDate = datePart.split("/")
                var daypart = arrBrisDate[0]
                var monthpart = arrBrisDate[1]
                var yearpart = arrBrisDate[2]

                var newStringBrisTime = monthpart + '/' + daypart + '/' + yearpart;
                var newFullStringBrisTime = newStringBrisTime + ',' + arrCountryTime[1];
                var currentBrisDate = new Date(newFullStringBrisTime);

                if (!(currentBrisDate instanceof Date && !isNaN(currentBrisDate))) {
                    var currentBrisDate = new Date(currentBrisbaneTime);
                }

                if (currentBrisDate >= start && currentBrisDate <= end) {
                    _THIS.removeClass('hide')
                } else {
                    _THIS.parent().find(".product-item-flag").removeClass("hide");
                }

            } else {
                return
            }

        } catch (err) {
            //console.log(err)
            return;
        }


    })

}

export function sendGTAForMenu(menuCategory, curMenuText) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'menuClick',
        'event_category': menuCategory,
        'event_label': curMenuText
    });
}